import { Component, OnInit, Pipe } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import {
  faAngleLeft,
  faAngleRight,
  faCheckCircle,
  faChevronLeft,
  faChevronRight,
  faEdit,
  faFileExport,
  faInfoCircle,
  faLink,
  faLock,
  faPlus,
  faProjectDiagram,
  faRedo,
  faSave,
  faSearch,
  faStepBackward,
  faStepForward,
  faTasks,
  faTimes,
  faTrashAlt,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
import { MainComponent } from '../main/main.component';
import { InteractionMapperComponent } from '../interaction-mapper/interaction-mapper.component';
import { PlannerComponent } from '../planner/planner.component';
import { faConnectdevelop } from '@fortawesome/free-brands-svg-icons';
declare var $: any;
import { UserManagementService } from '../shared/services/user-management.service';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { SocketService } from '../shared/services/socket.service';
import { Subscription } from 'rxjs';
import { ReloadToolService } from '../shared/services/reload-tool.service';

@Component({
  selector: 'app-sprint-planner-plus',
  templateUrl: './sprint-planner-plus.component.html',
  styleUrls: ['./sprint-planner-plus.component.scss']
})
export class SprintPlannerPlusComponent implements OnInit {
  /// icons

  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faStepForward = faStepForward;
  faAngleRight = faAngleRight;
  faAngleLeft = faAngleLeft;
  faStepBackward = faStepBackward;
  faFileExport = faFileExport;
  faProjectDiagram = faProjectDiagram;
  faUser = faUser;
  faInfoCircle = faInfoCircle;
  faConnectdevelop = faConnectdevelop;
  faLink = faLink;
  faTrashAlt = faTrashAlt;
  faCircle = faCircle;
  faCheckCircle = faCheckCircle;
  faRedo = faRedo;
  faSave = faSave;
  faPlus = faPlus;
  faSearch = faSearch;
  faLock = faLock;
  faTimes = faTimes;
  faEdit = faEdit;
  faTasks = faTasks;
  clickEventsubscriptionSocket: Subscription;
  jiraDataSubscription: Subscription = new Subscription();
  jiraProjectData: any = [];
  selectedSprintDetails: any;

  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private socketService: SocketService,
    private reloadToolService: ReloadToolService,
    private Config: Config,
    private appService: AppService,
    public mainComponent: MainComponent,
    public plannerComponent: PlannerComponent,
    public interactionMapperComponent: InteractionMapperComponent,
    private userManagementService: UserManagementService
  ) {
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });
  }

  filterTypeCount: any = { type: 'count' };
  filterTypeList: any = { type: 'list' };
  modelData: any;
  /// app code open

  planner: any;
  listOfEUTs: any;
  listOfAttributes: any;
  listOfEnv: any;
  projectUserList: any;
  EUTdetails: any;
  entityModel: any;
  tasks: any;
  appConstlistOfAttributes: any;
  scopeMap: any;
  scenarios: any;
  runinfo: any;
  // AppService: any;
  ProjectService: any;
  interactionMap: any;
  suites: any;
  checklists: any;
  personaMap: any;
  addEntityType: any = 'TF';
  eutFound: any;
  selectedAttributesArray: any = [];
  impactedEntitySelected: any = {};
  /// app code
  /// model variables open

  model: any = {
    listOfEUTs: '',
    EUTdetails: '',
    scopeMap: '',
    interactionMap: '',
    personaMap: '',
    entityModel: '',
    listOfAttributes: '',
    scenarios: '',
    listOfEnv: '',
    projectUserList: '',
    tasks: '',
    checklists: '',
    appConstlistOfAttributes: '',
    AppService: '',
    planner: '',
    suites: '',
    delTaskDetails: '',
    totalEnvs: [],
    choosenEntity: '',
    entityTypes: ['TF', 'UR', 'BF'],
    mappedEntities: [],
    mappedEntitiesChoosen: [],
    taskID: '',
    taskIndex: '',
    matchedTaskEntity: {},
    sprintTasks: '',
    selectedSprintEUTs: []
  };

  /// model vaiables close

  /// ctrl vars
  index: any;
  entityName: any;
  selectedEntity: any;
  selectedEntityId: any;
  eutTypes: any;
  activityTypes: any;
  activityDisabled: any;
  selectedEUT: any;
  selectedActivity: any;
  selectedActivityObj: any;
  attributeSelected: any;
  selectedEnvironment: any;
  selectedSuite: any;
  selectedSuiteName: any;
  freeFormTestData: any;
  selectedChecklist: any;
  publicChecklists: any;
  testTypes: any;
  selectedPerson: any = '';
  plannerID: any = '';
  modalPlannerName: any = '';
  toastMsg: any = '';
  newTaskDetails: any = {};
  editTaskDetails: any = {};
  delTaskDetails: any = {};
  ModifiedTaskDetails: any = {};
  taskSelectedForModify: any = false;
  taskCombineId: any = '';
  taskID: any = '';
  finalTaskList: any = '';
  taskPlanner: any = '';
  planDropdown: any = false;
  planName: any = true;
  AttPlus: any = 1;
  EnvPlus: any = 1;
  sprintName: any = '';
  sprintID: any;
  sprintTasks: any;
  sprintEUTs: any;
  userstoryName: any;
  userDetails: any
  mySprintPlannerList: any = [];
  userIDTemp: any = localStorage.getItem('userID');
  currentProjectID: any = localStorage.getItem('projectID');
  fieldsDisabled: any = true;
  plannerPlusBtn: any = false;
  planNameField: any = false;
  showText: any = false;
  updateSprintname: any = false;
  new: any = true;
  singleEnvironmentName: any = '';

  sprintNamesArray: any = [];
  tempSprintNamesArray: any = [];
  oldSprintName: any;


  checkListArray: any = [];
  tempChecklistNames: any = [];
  attrDisabled: any = false;
  selectEnvSubstr: any = '';
  envMapArrayList: any = [];
  hideEUTDD: any = false;
  hideClistDD: any = true;
  hideEnvDD: any = true;
  hideSuitesDD: any = true;
  hideFTField: any = true;
  personName: any;
  matchedAttribute: any;
  envDDDisabled: any;
  EUTTypeDDisabled: any;
  EUTDDisabled: any;
  updatedTaskList: any;
  attributeName: any;
  environmentName: any;
  mapText: any;
  selectedTaskId: any;
  matchedScenario: any;
  matchedRuninfo: any;
  taskIndex: any;
  choosenEntity: any;
  mappedEntitiesChoosen: any;
  impactedEntitiesChoosen: any = [];
  mappedEntities: any;
  unmappedEntities: any;
  entityTypes: any;
  matchedTaskEntity: any;
  toastMsgPopup: any;
  searchText: any;
  checksearchText: any;
  addEUTModel: any;
  addEnvModel: any;
  eutsearchText: string = '';
  entityMultipleAdd: any = [{
    "entityDesc": '',
    "type": 'TF'
  }]
  impactedentityMultipleAdd: any = [{
    "entityDesc": '',
    "type": 'TF'
  }]
  showSprintEntityList = 'platform';
  showImpactedEntityList = 'platform';
  selectedSprintEUT: any = 'TF';
  selectedSprintEUTImpact: any = 'TF';

  ngOnInit(): void {
    setTimeout(() => {
      this.getVideoURL('Tp1');
    }, 2000);
    // this.changeAxisTab('yAxis');
    this.jiraDataSubscription = this._sharedService.jiraProDataSubject.subscribe(stories => {
      this.jiraProjectData = stories;
    });
    this.modelData = this._sharedService.loadedProjectData.model;
    this.listOfEUTs = this.modelData.listOfEUTs;
    this.listOfAttributes = this.modelData.listOfAttributes;
    this.listOfEnv = this.modelData.envMap;
    this.EUTdetails = this.modelData.EUTdetails;
    this.tasks = this.modelData.tasks;
    this.appConstlistOfAttributes = this.Config.listOfAttributes;
    this.scopeMap = this.modelData.scopeMap;
    this.scenarios = this.modelData.scenarios;
    this.runinfo = this.modelData.runInfo;
    this.interactionMap = this.modelData.interactionMap;
    this.suites = this.modelData.suites;
    this.checklists = this.modelData.checklists;
    this.personaMap = this.modelData.personaMap;
    this.planner = this.plannerComponent;
    this.projectUserList = this.mainComponent.projectUserList;
    if (this.mainComponent.projectUserList.length <= 0) {
      this.getProjectUsersByProjectID(this.currentProjectID);
    }
    /// controller vars open

    this.index = 0;
    this.entityName = '';
    this.selectedEntity = '';
    this.selectedEntityId = '';
    this.eutTypes = ['TF', 'UR', 'BF'];
    this.activityTypes = [
      { type: 'TN', name: 'Test', shortfoam: 'Test' },
      { type: 'RM', name: 'Re-test', shortfoam: 'R-Test' },
      { type: 'CL', name: 'Test type', shortfoam: 'T-Type' },
      { type: 'FT', name: 'Do', shortfoam: 'Do' },
    ];
    this.activityDisabled = true;
    this.selectedEUT = 'TF';
    this.selectedActivity = 'Test';
    this.selectedActivityObj = {
      type: 'TN',
      name: 'Test',
      shortfoam: 'Test',
    };
    this.selectedAttributesArray.splice(0, this.selectedAttributesArray.length);
    this.attributeSelected = [];
    this.selectedEnvironment = '';
    this.selectedSuite = {};
    this.selectedSuiteName = '';
    this.freeFormTestData = '';
    this.selectedChecklist = {};
    this.publicChecklists = [];
    this.testTypes = [
      {
        name: 'Feature Behaviour',
        symbol: 'Fe',
        eType: 'TF',
      },
      {
        name: 'Requirement Behaviour',
        symbol: 'Rb',
        eType: 'UR',
      },
      {
        name: 'Flow Behaviour',
        symbol: 'Fb',
        eType: 'BF',
      },
    ];
    this.tasks = this.modelData.tasks;

    if (this.projectUserList.length == 1) {
      let person = this.projectUserList.find(
        (person: any) => person._id == this.userIDTemp
      );
      this.loadPersonDetails(person);
    } else {
      this.personName = '';
      this.selectedPerson = '';
    }
    this.sprintTasks = this.modelData.sprintTasks;
    this.sprintEUTs = this.modelData.sprintEUTs;

    this.loadSprintNamesList(this.sprintEUTs);
    this.envMapListGenerate();

    /// controller vars close
    /// model vars
    this.model.listOfEUTs = this.modelData.listOfEUTs;
    this.model.EUTdetails = this.modelData.EUTdetails;
    this.model.scopeMap = this.modelData.scopeMap;
    this.model.interactionMap = this.modelData.interactionMap;
    this.model.personaMap = this.modelData.personaMap;
    this.model.listOfAttributes = this.Config.listOfAttributes;
    this.model.scenarios = this.modelData.scenarios;
    this.model.listOfEnv = this.modelData.listOfEnv;
    this.model.projectUserList = this.mainComponent.projectUserList;
    this.model.tasks = this.modelData.tasks;
    this.model.checklists = this.modelData.checklists;
    this.model.appConstlistOfAttributes = this.Config.listOfAttributes;
    // this.model.AppService = this.Config.listOfAttributes;
    this.model.planner = this.plannerComponent;
    this.model.suites = this.modelData.suites;
    for (let i = 0; i < this.listOfEnv.length; i++) {
      for (let j = 0; j < this.listOfEnv[i].envList.length; j++) {
        this.model.totalEnvs.push(this.listOfEnv[i].envList[j]);
      }
    }
    setInterval(() => {
      this.updateProjectData();
    }, 2000);
    this.getPublicChecklists();
    setTimeout(() => {
      this.updateEtypeinJirastories();
    }, 3000);
  }

  updateEtypeinJirastories() {
    if (this.jiraProjectData) {
      for (let j = 0; j < this.jiraProjectData.length; j++) {
        this.jiraProjectData[j].fields['eType'] = 'TF';
        console.log('jiraProjectData', this.jiraProjectData[j]);
      }
      console.log('jiraProjectData in sprint', this.jiraProjectData);
    }
  }

  checkImpactedEUT(eut: any) {
    // console.log("EUT", eut.eID);
    // console.log("scope", this.impactedEntitySelected);
    // console.log("mapp", this.modelData.interactionMap);
    let mapFound = this.modelData.interactionMap.find((map: any) => map.eut1 == eut.eID && map.eut2 == this.impactedEntitySelected.entity_Id);
    if (mapFound) {
      this.impactedEntitiesChoosen.push(eut);
      return true;
    } else {
      // this.impactedEntitiesChoosen = this.impactedEntitiesChoosen.filter(
      //   (obj: any) => {
      //     return obj.eID !== eut.eID;
      //   })
      return false;
    }
  }

  addRow() {
    let obj = {
      "entityDesc": '',
      "type": 'TF'
    };
    this.entityMultipleAdd.push(obj);
    console.log("Add", this.entityMultipleAdd);
  }
  impactedaddRow() {
    let obj = {
      "entityDesc": '',
      "type": 'TF'
    };
    this.impactedentityMultipleAdd.push(obj);
    console.log("Add", this.impactedentityMultipleAdd);
  }
  deleteRow(index: any) {
    if (this.entityMultipleAdd.length > 1) {
      this.entityMultipleAdd.splice(index, 1);
    } else {
      alert("Entity can't be deleted!!")
    }
    console.log("Del", this.entityMultipleAdd);
  }
  impacteddeleteRow(index: any) {
    if (this.impactedentityMultipleAdd.length > 1) {
      this.impactedentityMultipleAdd.splice(index, 1);
    } else {
      alert("Entity can't be deleted!!")
    }
    console.log("Del", this.impactedentityMultipleAdd);
  }
  updateEUTType(type: any, index: any) {
    this.entityMultipleAdd[index]['type'] = type;
    console.log("Type", this.entityMultipleAdd[index]);
  }
  impactedupdateEUTType(type: any, index: any) {
    this.impactedentityMultipleAdd[index]['type'] = type;
    console.log("Type", this.entityMultipleAdd[index]);
  }
  updateJiraEUTType(type: any, index: any) {
    this.jiraProjectData[index].fields['eType'] = type;
    console.log("Type", this.jiraProjectData[index].fields.type);
    console.log("obj", this.jiraProjectData[index].fields);
  }

  addMultipleEuts() {
    console.log("Array", this.entityMultipleAdd);
    for (let i = 0; i < this.entityMultipleAdd.length; i++) {
      console.log(this.entityMultipleAdd[i]);
      if (this.entityMultipleAdd[i].entityDesc != '') {
        this.addEut(this.entityMultipleAdd[i], 'sprint');
      }
      if (i == this.entityMultipleAdd.length - 1) {
        this.entityMultipleAdd = [];
      }
    }
    this.addRow();
  }

  addMultipleImpactedEuts() {
    console.log("Array", this.impactedentityMultipleAdd);
    for (let i = 0; i < this.impactedentityMultipleAdd.length; i++) {
      console.log(this.impactedentityMultipleAdd[i]);
      if (this.impactedentityMultipleAdd[i].entityDesc != '') {
        this.addEut(this.impactedentityMultipleAdd[i], 'impacted');
      }
      if (i == this.impactedentityMultipleAdd.length - 1) {
        this.impactedentityMultipleAdd = [];
      }
    }
    this.impactedaddRow();
  }

  getJiraEUTType(fields: any) {
    this.sprintEUTs
    let eutFound = this.modelData.sprintEUTs.find((eut: any) => eut.eName === fields.summary);
    if (eutFound) {
      return eutFound.eType;
    }
  }

  chooseImpactedEUTs(eut: any, event: any) {
    if (event == true) {
      this.impactedEntitiesChoosen.push(eut);
    } else {
      this.impactedEntitiesChoosen = this.impactedEntitiesChoosen.filter(
        (obj: any) => {
          return obj.eID !== eut.eID;
        }
      );
    }
    console.log("Impact", this.impactedEntitiesChoosen);
  }

  createImpactedTask() {
    // console.log("selectedEUT", this.impactedEntitySelected);
    // console.log("Impact", this.impactedEntitiesChoosen);
    for (let i = 0; i < this.impactedEntitiesChoosen.length; i++) {

      let ImptaskCreateArray = ['de', 'ex'];
      let taskDetails = {
        "activity": { type: 'RI', name: 'Re-test', shortfoam: 'R-Test' },
        "sprintName": this.impactedEntitySelected.sprintName,
        "entity_Id": this.impactedEntitiesChoosen[i].eID,
        "entityType": this.impactedEntitiesChoosen[i].eType,
        "entity_desc": this.impactedEntitiesChoosen[i].eName,
        "environment": this.impactedEntitySelected.environment
      }

      this.createTask(taskDetails, this.impactedEntitySelected.task_combine_id, ImptaskCreateArray, this.impactedEntitySelected.attributes, this.editTaskDetails, this.impactedEntitySelected.entity_Id);
      this.updateInteractionMap(this.impactedEntitySelected.entity_Id, this.impactedEntitiesChoosen[i].eID);
      if (i == this.impactedEntitiesChoosen.length - 1) {
        this.tableCollapseExpand();
      }
    }


  }
  updateInteractionMap(eut2: any, eut1: any) {
    console.log("Interaction", eut2, eut1);
    let interactionMapFound = this.modelData.interactionMap.find(
      (interact: any) => interact.eut2 == eut2 && interact.eut1 == eut1
    );
    if (!interactionMapFound) {
      let interact = {
        "eut2": eut2,
        "eut1": eut1
      }
      this.modelData.interactionMap.push(interact);
      console.log("interact",this.modelData.interactMap);
    }
  }

  getPublicChecklists() {
    this.ProjectServices.getPublicChecklists().subscribe((response: any) => {
      console.log(response, 'res');
      if (response.statusCode == 200) {
        this.publicChecklists = response.records;
      } else {
      }
    });
  }
  updateProjectData() {
    this._sharedService.projectContent(this.modelData);
  }
  addEutType(type: any) {
    this.addEntityType = type;
  }
  addEut(eut: any, type: any) {
    let eutObj = {
      "entity_desc": eut.entityDesc
    }
    if (this.checkEUTExists(eutObj) === true) {
      this.triggerToastPopup(this.appService.getResourceText('V031'));
      // return;
    } else {
      //Adding userstory/EUT to the eutlist
      let obj = {
        "eID": this.uniqueID(eut.type),
        "eName": eut.entityDesc,
        "eType": eut.type,
        "scenarioCount": 0
      }
      this.modelData.listOfEUTs.unshift(obj);
      // this.addEUTModel = '';
      // this.addEntityType = 'TF';
      // this.loadEntityDetails(obj, false)
      if (type == 'sprint') {
        this.selectSprintEUTs(obj, true);
      }
      if (type == 'impacted') {
        this.chooseImpactedEUTs(obj, true);
      }
    }

  }
  // checkEUTExists(newTaskDetails: any) {
  //   console.log(newTaskDetails);
  //   console.log("EUT", this.modelData.listOfEUTs);
  //   this.eutFound = this.modelData.listOfEUTs.find(
  //     (eut: any) => eut.eName == newTaskDetails.entity_desc
  //   );
  //   console.log("founfd", this.eutFound);
  //   if (this.eutFound) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  mapEutToAtt(attr: string, check: boolean) {
    check
      ? this.addAttr(attr)
      : this.deleteAttr(attr);
  }

  addAttr(att: any) {
    this.selectedAttributesArray.push(att);
    console.log("add.selectedAttributesArray", this.selectedAttributesArray);
  }

  deleteAttr(att: any) {
    let index = this.selectedAttributesArray.findIndex(
      (map: any) => map.symbol == att.symbol
    );
    if (index > -1) {
      this.selectedAttributesArray.splice(index, 1);
    }
    console.log("delete.selectedAttributesArray", this.selectedAttributesArray);
  }
  //Check whether the attribute in list is present in the scope map for the choosen eut
  isCheckedAtt(attribute: any) {
    if (this.selectedAttributesArray.length > 0) {
      let a = this.selectedAttributesArray.findIndex((a: any) => a.symbol == attribute.symbol);
      return a > -1 ? true : false;
    } else {
      return false;
    }
  }
  //generation of unique id for userstory/entity
  uniqueID(type: any) {
    let model = this;
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (
      type +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    );
  }
  getProjectUsersByProjectID(currProject: any) {
    // this.userManagementService
    //   .getUsersFromProjectByID(currProject)
    //   .subscribe((response: any) => {
    //     console.log('getUsersFromProjectByID res', response);
    //     if (response.statusCode == 200) {
    //       this.projectUserList = response.records;
    //       this.model.projectUserList = response.records;
    //     } else {
    //     }
    //   });
  }

  /// ctrl fn open

  envMapListGenerate() {
    // console.log('this.listOfEnv in TP', this.listOfEnv);
    this.envMapArrayList = [];
    console.log("before", this.model.listOfEnv);
    for (let i = 0; i < this.model.listOfEnv.length; i++) {
      if (this.model.listOfEnv[i].envType == "Freeform") {
        let obj: any = {};
        let envSubstr = this.model.listOfEnv[i].envType.substring(0, 2);
        let envCode = envSubstr.toUpperCase();
        let envname =
          envCode + '1.' + (i + 1) + '(' + this.model.listOfEnv[i].envValues[0] + ')';
        obj['name'] = envname;
        obj['value'] = this.model.listOfEnv[i].envValues;
        this.envMapArrayList.push(obj);
      } else {
        for (let j = 0; j < this.model.listOfEnv[i].envValues.length; j++) {
          let obj: any = {};
          let envSubstr = this.model.listOfEnv[i].envType.substring(0, 2);
          let envCode = envSubstr.toUpperCase();
          let envname =
            envCode + '1.' + (j + 1) + '(' + this.model.listOfEnv[i].envValues[j] + ')';
          obj['name'] = envname;
          obj['value'] = this.model.listOfEnv[i].envValues[j];
          this.envMapArrayList.push(obj);
        }
      }
    }
    console.log('envMapArrayList', this.envMapArrayList);
  }

  checkAttributeDesc(Attribute: any, checkFor: any) {
    let concatAttr = Attribute.name + ' (' + Attribute.symbol + ')';
    this.matchedAttribute = this.listOfAttributes.find(
      (att: any) => att.aType == concatAttr
    );
    if (this.matchedAttribute) {
      if (this.matchedAttribute.aDetail == '') {
        if (checkFor == 'text') {
          return 'attributeNoFont';
        } else {
          return true;
        }
      } else {
        if (checkFor == 'text') {
          return 'attributeFont';
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }

  // new code open

  changeEnvironment(env: any) {
    // console.log('selectedEnvironment env', env);
    this.selectedEnvironment = '';
    this.singleEnvironmentName = env;
    this.selectedEnvironment = env;
  }
  changeSuite(suite: any) {
    // console.log('suite', suite);
    this.selectedSuite = suite;
    this.selectedSuiteName = suite.suiteName;
    this.envDDDisabled = false;
  }
  loadCheckList(scenarios: any) {
    this.checkListArray = [];
    this.tempChecklistNames = [];
    for (let i = 0; i < scenarios.length; i++) {
      if (scenarios[i].checklist != '' && scenarios[i].checklist != undefined) {
        this.tempChecklistNames.push(scenarios[i].checklist);
      }
      if (i == scenarios.length - 1) {
        this.tempChecklistNames = this.getUnique(this.tempChecklistNames);
        for (let p = 0; p < this.tempChecklistNames.length; p++) {
          let tempCheckList: any = {};
          tempCheckList.checklist = this.tempChecklistNames[p];
          tempCheckList.checklistID = this.uuidv4();
          this.checkListArray.push(tempCheckList);
        }
      }
    }
  }
  // new code close
  fieldsEnable(planName: any) {
    this.planDropdown = true;
    this.showText = false;
    this.planName = false;
    this.fieldsDisabled = false;
  }
  planNameFieldEnable(planName: any) {
    if (planName != '') {
      this.fieldsDisabled = true;
      this.planNameField = false;
      this.plannerPlusBtn = false;
    }
  }

  resetPlanField(newname: any, planID: any) {
    console.log('resetPlanField newname', newname);
    console.log('resetPlanField planID', planID);
    this.fieldsDisabled = false;
    this.showText = false;
    this.new = false;
    this.sprintName = newname;
    this.plannerID = planID;
    this.selectedSprintDetails = { sprintID: planID, sprintName: newname };
    this.sprintNamesArray.push(this.selectedSprintDetails);
    this.updateSprintname = false;
    this.fieldsDisabled = false;
    this.activityDisabled = false;
    this.selectedSuite = {};
    this.selectedSuiteName = '';
    this.freeFormTestData = '';
    this.envDDDisabled = true;
    if (this.model.projectUserList.length <= 1) {
      let person = this.model.projectUserList.find(
        (person: any) => person._id == this.userIDTemp
      );
      this.loadPersonDetails(person);
    } else {
      this.personName = '';
      this.selectedPerson = '';
    }
    this.changeActivity({ type: 'TN', name: 'Test', shortfoam: 'Test' });
  }

  editPlanname(oldName: any) {
    this.showText = true;
    this.updateSprintname = true;
    this.oldSprintName = oldName;
  }

  clear() {
    this.showText = false;
    if (this.updateSprintname == true) {
      this.sprintName = this.oldSprintName;
      this.updateSprintname == false;
      this.tableCollapseExpand();
    } else if (this.updateSprintname == false) {
      if (this.oldSprintName != '') {
        this.sprintName = this.oldSprintName;
        this.selectedSprint(false, false, '');
        // this.tableCollapseExpand(0, 0, '');
      } else {
        this.sprintName = this.oldSprintName;
        this.selectedSprint(false, false, '');
      }
    }
  }

  deletePlan(planname: any) {
    this.deletePlanModel(planname);
    this.sprintName = '';
    // this.selectedSprintDetails = {};
    this.plannerID = '';
    this.loadSprintNamesList(this.sprintTasks);
    // this.tableCollapseExpand(0, 0, '');
    this.resetTaskData();
    this.selectedSprint(false, false, this.selectedSprintDetails);
    if (this.model.projectUserList.length <= 1) {
      let person = this.model.projectUserList.find(
        (person: any) => person._id == this.userIDTemp
      );
      this.loadPersonDetails(person);
    } else {
      this.personName = '';
      this.selectedPerson = '';
    }
    this.changeActivity({ type: 'TN', name: 'Test', shortfoam: 'Test' });
    // this.plannerComponent.loadMytasksList(this.tasks);
    this.reloadToolService.triggerToolSprint(this.sprintTasks);
  }

  taskToBeDelete(task: any) {
    this.delTaskDetails = task;
  }
  activate(eut: any) {
    // this.loadEntityDetails(eut);
    this.index = this.eutTypes.findIndex((type: any) => type == eut.eType);
  }
  loadSprintNamesList(sprintEUTs: any) {
    this.sprintNamesArray = [];
    this.tempSprintNamesArray = [];
    for (let t = 0; t < sprintEUTs.length; t++) {
      if (
        sprintEUTs[t].sprintName != '' &&
        sprintEUTs[t].sprintName != undefined &&
        sprintEUTs[t].sprintName != null
      ) {
        this.tempSprintNamesArray.push(sprintEUTs[t].sprintName);
      }
      if (t == sprintEUTs.length - 1) {
        this.tempSprintNamesArray = this.getUnique(this.tempSprintNamesArray);
        for (let p = 0; p < this.tempSprintNamesArray.length; p++) {
          let tempPlan: any = {};
          tempPlan.sprintName = this.tempSprintNamesArray[p];
          let tempPlanIDFound = sprintEUTs.find(
            (task: any) => task.sprintName == this.tempSprintNamesArray[p]);
          tempPlan.sprintID = tempPlanIDFound.sprintID;
          this.sprintNamesArray.push(tempPlan);
        }
      }
    }
  }


  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        let r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  selectedSprint(newButton: any, textBox: any, sprintDetails: any) {
    console.log("selectedSprint", sprintDetails);
    this.selectedSprintDetails = sprintDetails;
    const planName = this.selectedSprintDetails.sprintName;
    if (this.updateSprintname == true) {
      this.loadSprintNamesList(this.sprintTasks);
    }
    if (planName != '') {
      let planIDFound = this.sprintNamesArray.find(
        (plan: any) => plan.sprintName == planName
      );
      if (planIDFound) {
        this.plannerID = planIDFound.plan_id;
      }
    } else if (planName != '') {
      this.plannerID = '';
    }
    this.oldSprintName = this.sprintName;
    this.updateSprintname = false;
    this.sprintName = planName;
    this.new = newButton;
    this.showText = textBox;
    if (this.sprintName != '') {
      this.fieldsDisabled = false;
      this.activityDisabled = false;
      this.tableCollapseExpand();
      this.changeActivity({ type: 'TN', name: 'Test', shortfoam: 'Test' });
    } else {
      this.fieldsDisabled = true;
      this.activityDisabled = true;
      this.mySprintPlannerList = [];
    }
    if (this.EUTTypeDDisabled == true) {
      this.activityDisabled = false;
      this.EUTTypeDDisabled = false;
      this.EUTDDisabled = false;
    }
    if (this.model.projectUserList.length <= 1) {
      let person = this.model.projectUserList.find(
        (person: any) => person._id == this.userIDTemp
      );
      this.loadPersonDetails(person);
    } else {
      this.personName = '';
      this.selectedPerson = '';
    }
  }


  getUnique(array: any) {
    let uniqueArray = [];

    // Loop through array values
    if (array) {
      for (let i = 0; i < array.length; i++) {
        if (uniqueArray.indexOf(array[i]) === -1) {
          uniqueArray.push(array[i]);
        }
      }
    }
    return uniqueArray;
  }
  //changing the entity type by toggling the span button
  //reset the entity name and details populated in the form
  changeEntity(test: any) {
    if (this.editTaskDetails.activity) {
      this.selectedEUT = test;
      this.index = this.eutTypes.findIndex((type: any) => type == test);
      // entity dd restting
      this.entityName = '';
      this.selectedEntity = '';
      this.selectedEntityId = '';
      // attr dd resetting
      this.selectedAttributesArray.splice(0, this.selectedAttributesArray.length);
    } else {
      this.attributeSelected = [];
      this.attrDisabled = false;
      this.selectedEUT = test;
      this.plannerPlusBtn = false;
      this.planNameField = false;
      this.index = this.eutTypes.findIndex((type: any) => type == test);
      this.selectedEntity = '';
      this.selectedAttributesArray.splice(0, this.selectedAttributesArray.length);
      this.selectedEnvironment = '';
      this.selectedPerson = '';
      this.entityName = '';
      this.attributeName = '';
      this.environmentName = '';
      this.singleEnvironmentName = '';
      this.personName = '';
      this.taskSelectedForModify = false;
      this.taskCombineId = '';
      this.taskID = '';
    }

    if (this.sprintName != '') {
      this.fieldsDisabled = false;
    } else {
      this.fieldsDisabled = true;
    }

    if (this.selectedEUT == 'TT') {
      this.allAttrList(this.selectedEUT);
    }

    if (this.model.projectUserList.length <= 1) {
      let person = this.model.projectUserList.find(
        (person: any) => person._id == this.userIDTemp
      );
      this.loadPersonDetails(person);
    } else {
      this.personName = '';
      this.selectedPerson = '';
    }
  }


  //changing the entity type by toggling the span button
  //reset the entity name and details populated in the form
  changeSprintEntity(test: any) {
    this.selectedSprintEUT = test;
    this.index = this.eutTypes.findIndex((type: any) => type == test);
  }

  changeSprintEntityImpact(test: any) {
    this.selectedSprintEUTImpact = test;
    this.index = this.eutTypes.findIndex((type: any) => type == test);
  }

  changeActivity(activity: any) {
    // console.log('activity', activity);
    this.selectedActivityObj = activity;
    this.selectedActivity = activity.shortfoam;
    if (this.sprintName != '') {
      this.fieldsDisabled = false;
    } else {
      this.fieldsDisabled = true;
    }
    if (
      activity.type == 'TN' ||
      activity.type == 'RF' ||
      activity.type == 'RM'
    ) {
      this.hideEUTDD = false;
      this.hideClistDD = true;
      this.hideEnvDD = true;
      this.hideSuitesDD = true;
      this.hideFTField = true;
      this.changeEntity('TF');
    } else if (activity.type == 'CL') {
      this.hideEUTDD = true;
      this.hideClistDD = false;
      this.hideEnvDD = false;
      this.hideSuitesDD = true;
      this.hideFTField = true;
      this.attrDisabled = false;
      this.envDDDisabled = true;
      this.selectedEnvironment = '';
      this.singleEnvironmentName = '';
      this.selectedPerson = '';
      this.entityName = '';
      this.attributeName = '';
      this.environmentName = '';
      this.personName = '';
      this.taskSelectedForModify = false;
      this.taskCombineId = '';
      this.taskID = '';
      this.freeFormTestData = '';
      if (this.model.projectUserList.length <= 1) {
        let person = this.model.projectUserList.find(
          (person: any) => person._id == this.userIDTemp
        );
        this.loadPersonDetails(person);
      } else {
        this.personName = '';
        this.selectedPerson = '';
      }
    } else if (activity.type == 'RS') {
      this.hideEUTDD = true;
      this.hideClistDD = true;
      this.hideEnvDD = false;
      this.hideSuitesDD = false;
      this.hideFTField = true;
      this.attrDisabled = false;
      this.envDDDisabled = true;
      this.selectedEnvironment = '';
      this.singleEnvironmentName = '';
      this.selectedPerson = '';
      this.entityName = '';
      this.attributeName = '';
      this.environmentName = '';
      this.personName = '';
      this.taskSelectedForModify = false;
      this.taskCombineId = '';
      this.taskID = '';
      this.freeFormTestData = '';
      if (this.model.projectUserList.length <= 1) {
        let person = this.model.projectUserList.find(
          (person: any) => person._id == this.userIDTemp
        );
        this.loadPersonDetails(person);
      } else {
        this.personName = '';
        this.selectedPerson = '';
      }
    } else if (activity.type == 'FT') {
      this.hideEUTDD = true;
      this.hideClistDD = true;
      this.hideEnvDD = true;
      this.hideSuitesDD = true;
      this.hideFTField = false;
      this.selectedEnvironment = '';
      this.selectedPerson = '';
      this.entityName = '';
      this.attributeName = '';
      this.environmentName = '';
      this.singleEnvironmentName = '';
      this.personName = '';
      this.taskSelectedForModify = false;
      this.taskCombineId = '';
      this.taskID = '';
      this.freeFormTestData = '';
      if (this.model.projectUserList.length <= 1) {
        let person = this.model.projectUserList.find(
          (person: any) => person._id == this.userIDTemp
        );
        this.loadPersonDetails(person);
      } else {
        this.personName = '';
        this.selectedPerson = '';
      }
    }
  }
  allAttrList(eut: any) {
    if (eut == 'TT') {
      for (let r = 0; r < this.model.appConstlistOfAttributes.length; r++) {
        this.loadAttrList(this.model.appConstlistOfAttributes[r]);
      }
    }
  }
  selectEut(test: any) {
    this.selectedEUT = test;
    this.selectedEntity = {};
    this.entityName = '';
    this.mapText = '';
  }
  // resets the selected dropdowns
  resetTaskData() {
    this.selectedEnvironment = '';
    this.attributeSelected = [];
    this.selectedPerson = '';
    this.entityName = '';
    this.attributeName = '';
    this.environmentName = '';
    this.singleEnvironmentName = '';
    this.personName = '';
    this.taskSelectedForModify = false;
    this.taskCombineId = '';
    this.taskID = '';
    this.attrDisabled = false;
    this.selectedSuite = {};
    this.selectedSuiteName = '';
    this.freeFormTestData = '';
    this.selectedChecklist = {};
    this.envDDDisabled = true;
    this.activityDisabled = false;
    this.selectedActivity = 'Test';
    this.selectedActivityObj = {
      type: 'TN',
      name: 'Test',
      shortfoam: 'Test',
    };
    this.changeActivity(this.selectedActivityObj);
    $('#taskPlannerListTable tr').removeClass('active');

    this.selectedAttributesArray.splice(0, this.selectedAttributesArray.length);
    if (this.selectedEUT == 'TT') {
      this.selectedAttributesArray.splice(0, this.selectedAttributesArray.length);
      this.allAttrList(this.selectedEUT);
    }
    if (this.EUTTypeDDisabled == true) {
      this.activityDisabled = false;
      this.EUTTypeDDisabled = false;
      this.EUTDDisabled = false;
    }
    this.editTaskDetails = {};
    if (this.model.projectUserList.length <= 1) {
      let person = this.model.projectUserList.find(
        (person: any) => person._id == this.userIDTemp
      );
      this.loadPersonDetails(person);
    } else {
      this.personName = '';
      this.selectedPerson = '';
    }
  }

  chooseChecklist(checklist: any) {
    // console.log('checklist', checklist);
    this.selectedChecklist = checklist;
    this.envDDDisabled = false;
  }

  loadCheckListDetails(checklist: any) {
    this.entityName = checklist.checklist;
    this.matchedAttribute = this.appConstlistOfAttributes.find(
      (att: any) => att.symbol == checklist.tID
    );
    if (this.matchedAttribute) {
      // this.changeAttribute(this.matchedAttribute);
    }
    this.attrDisabled = true;
  }
  // handler to get the required details based on the selected entity
  loadEntityDetails(eutChosen: any, value: any) {
    console.log('loadEntityDetails eutChosen', eutChosen);
    this.selectedEUT = eutChosen.eType;
    this.attributeSelected = [];
    this.attributeName = '';
    this.selectedAttributesArray.splice(0, this.selectedAttributesArray.length);
    if (!this.editTaskDetails.activity) {
      this.selectedEnvironment = '';
      this.environmentName = '';
      if (value == false) {
        this.singleEnvironmentName = '';
      }
    }
    this.entityName = eutChosen.eName;
    this.selectedEntity = eutChosen.eName;
    this.selectedEntityId = eutChosen.eID;
    this.selectedTaskId = eutChosen.taskId;
    for (let l = 0; l < this.scopeMap.length; l++) {
      if (eutChosen.eID == this.scopeMap[l].eID) {
        this.loadAttrFromScopeMap(
          this.model.scopeMap.find(
            (scope: any) => scope.aType == this.scopeMap[l].aType
          )
        );
      }
    }

    if (this.selectedEUT == 'TT') {
      this.allAttrList(this.selectedEUT);
    }
  }

  loadAttrFromScopeMap(scope: any) {
    this.loadAttrList(
      this.model.appConstlistOfAttributes.find(
        (attr: any) => attr.symbol == scope.aType
      )
    );
  }

  loadAttrList(attr: any) {
    if (attr) {
      this.selectedAttributesArray.push(attr);
    }
  }



  loadEnvironmentDetails(envChoosen: any, event: any) {
    if (envChoosen != undefined) {
      if (event === true) {
        this.environmentName = envChoosen;
        this.selectedEnvironment = envChoosen;
      } else {
        this.environmentName = this.selectedEnvironment;
      }
    }
  }

  loadPersonDetails(personChoosen: any) {
    console.log('personChoosen', personChoosen);
    if (personChoosen == 'not assigned') {
      console.log('if1');

      this.personName = personChoosen;
      this.selectedPerson = personChoosen;
    } else if (personChoosen == undefined) {
      console.log('if12');

      this.personName = '';
      this.selectedPerson = '';
    } else {
      console.log('if123');

      this.personName = personChoosen.firstname;
      this.selectedPerson = personChoosen._id;
    }
  }

  deleteTaskFromPlannerList(taskDetails: any, value: boolean) {
    this.deleteTaskFromPlanner();
    this.deleteTaskFromPlannerListModel(taskDetails);
    // this.resetTaskDetails(value);
    this.tableCollapseExpand();
  }
  addTaskToPlanner() {
    console.log('this.editTaskDetails', this.editTaskDetails);
    // return;
    if (this.editTaskDetails.activity) {
      // if (this.editTaskDetails.activity.type == 'RI') {
      //   let updateObj = {
      //     attribute: this.selectedAttribute,
      //     attributeSymbol: this.selectedAttributesymbol,
      //     environment: this.selectedEnvironment,
      //     assignedID: this.selectedPerson,
      //     assignedUser: this.personName,
      //   };
      //   this.updateImpactedEntityTask(this.editTaskDetails, updateObj);
      //   this.editTaskDetails = '';
      //   this.selectedActivity = 'New';
      //   this.selectedActivityObj = {
      //     type: 'TN',
      //     name: 'Test-NEW',
      //     shortfoam: 'New',
      //   };
      //   this.tableCollapseExpand();
      //   this.resetTaskDetails(true);
      //   return;
      // } else if (
      //   this.editTaskDetails.activity.type == 'RF' ||
      //   this.editTaskDetails.activity.type == 'RM'
      // ) {
      //   if (
      //     this.editTaskDetails.entity_Id != this.selectedEntityId ||
      //     this.editTaskDetails.attribute != this.selectedAttribute
      //   ) {
      //     this.deleteTaskFromPlannerList(this.editTaskDetails, true);
      //   } else {
      //     this.updateModifyOrFixTask(
      //       this.editTaskDetails,
      //       this.selectedEnvironment,
      //       this.personName,
      //       this.selectedPerson
      //     );
      //     this.tableCollapseExpand();
      //     this.resetTaskDetails(true);
      //     this.loadSprintNamesList(this.tasks);
      //     return;
      //   }
      // } else {
      this.deleteTaskFromPlannerList(this.editTaskDetails, true);
      // }
    }
    if (this.sprintName == '') {
      this.triggerToastPopup(this.appService.getResourceText('V014'));
      return;
    }
    if (
      this.selectedActivityObj.type == 'TN' ||
      this.selectedActivityObj.type == 'RF' ||
      this.selectedActivityObj.type == 'RM'
    ) {
      console.log("Arraysele", this.selectedAttributesArray);
      if (this.selectedAttributesArray.length === 0) {
        this.triggerToastPopup(this.appService.getResourceText('V016'));
        return;
      }
    }
    this.newTaskDetails.task_desc = '';
    this.newTaskDetails.attributes = this.selectedAttributesArray;
    this.newTaskDetails.entity_Id = this.selectedEntityId;
    this.newTaskDetails.entity_desc = this.entityName;
    this.newTaskDetails.entityType = this.selectedEUT;
    this.newTaskDetails.environment = this.selectedEnvironment;
    this.newTaskDetails.sprintName = this.sprintName;
    // this.newTaskDetails.plan_id = this.plannerID;
    // if (this.selectedPerson == 'not assigned' || this.selectedPerson == '') {
    //   this.selectedPerson = 'not assigned';
    //   this.personName = 'not assigned';
    //   this.newTaskDetails.status = 0;
    // } else {
    //   this.newTaskDetails.status = 1;
    // }
    // this.newTaskDetails.assignedto = this.selectedPerson;
    // this.newTaskDetails.assigneduser = this.personName;
    this.newTaskDetails.activity = this.selectedActivityObj;
    // if (this.selectedActivityObj.type == 'FT') {
    //   if (this.freeFormTestData == '') {
    //     this.triggerToastPopup(this.appService.getResourceText('V020c'));
    //     return;
    //     // return -1; //// commented temporarily
    //   } else {
    //     this.newTaskDetails.task_desc = this.freeFormTestData;
    //   }
    // }
    // if (this.selectedActivityObj.type == 'RS') {
    //   if (this.selectedSuite.suiteName === undefined) {
    //     this.triggerToastPopup(this.appService.getResourceText('V020b'));
    //     return;
    //   } else {
    //     this.newTaskDetails.selectedSuite = this.selectedSuite;
    //   }

    // }
    // if (this.selectedActivityObj.type == 'CL') {
    //   if (this.selectedChecklist.checklistId === undefined) {
    //     this.triggerToastPopup(this.appService.getResourceText('V020a'));
    //     return;
    //   } else {
    //     this.newTaskDetails.checklistDetails = this.selectedChecklist;
    //   }
    // }
    // console.log(this.checkEUTExists(this.newTaskDetails));

    // if (this.checkEUTExists(this.newTaskDetails) === true) {
    //   this.triggerToastPopup(this.appService.getResourceText('V031'));
    //   return;
    // } else {
    this.checkTaskExists(this.newTaskDetails, this.editTaskDetails);
    // }
    // this.tableCollapseExpand();
    // this.loadSprintNamesList(this.tasks);
    // this.plannerComponent.loadMytasksList(this.tasks);
    this.reloadToolService.triggerToolSprint(this.sprintTasks);
    // console.log('newTaskDetails', this.newTaskDetails);
    // new entity add/update/duplicate check in landscape to be dine here
    // scope mapping to be done for selected attributes
    // tasks to be created for new/existing user story and assigned to self(who created)

  }
  checkEUTExists(newTaskDetails: any) {
    console.log(newTaskDetails);
    console.log("EUT", this.modelData.listOfEUTs);
    this.eutFound = this.modelData.listOfEUTs.find(
      (eut: any) => eut.eName == newTaskDetails.entity_desc
    );
    console.log("founfd", this.eutFound);
    if (this.eutFound) {
      return true;
    } else {
      return false;
    }
  }

  checkTaskExists(newTaskDetails: any, editTaskDetails: any) {
    let taskCombineUUID: any = this.uuidv4();
    // }
    let taskCreateArray: any = '';
    // this.createTask(newTaskDetails, this.editTaskDetails, taskCombineUUID, taskCreateArray,newTaskDetails.attributes[0]);
    // if (newTaskDetails.attributes.length > 1) {
    console.log("Attr", newTaskDetails.attributes);
    for (let i = 0; i < newTaskDetails.attributes.length; i++) {
      if (newTaskDetails.activity.type == 'TN') {
        if (i == 0) {
          taskCreateArray = ['dd', 'im', 'de', 'ex'];
        } else {
          taskCreateArray = ['de', 'ex'];
        }
      } else if (newTaskDetails.activity.type == 'RM') {
        taskCreateArray = ['de', 'ex'];
      }
      console.log("Attr", newTaskDetails.attributes[i]);
      this.createTask(newTaskDetails, taskCombineUUID, taskCreateArray, newTaskDetails.attributes[i], this.editTaskDetails, '');
      this.updateScopeMap(newTaskDetails, newTaskDetails.attributes[i]);
      // console.log("NEW", newTaskDetails);
      console.log("arr", taskCreateArray);
      if (i == newTaskDetails.attributes.length - 1) {
        this.tableCollapseExpand();
        this.resetTaskData();
      }
    }
    // }
    //  console.log("Scope",taskCreateArray);
    //  return;

    //Adding userstory/EUT to the eutlist
    // let obj = {
    //   "eID": newTaskDetails.entity_Id,
    //   "eName": newTaskDetails.entity_desc,
    //   "eType": newTaskDetails.entityType,
    //   "scenarioCount": 0
    // }
    // this.modelData.listOfEUTs.unshift(obj);
    // this.tableCollapseExpand();
    // this.resetTaskDetails(false);
  }

  createTask(taskDetails: any, taskCombineUUID: any, taskCreateArray: any, attributes: any, editDetails: any, primaryEUTId: any) {
    // console.log('taskDe', taskDetails);
    // return;
    // console.log("this.modelData.sprintTasks", this.modelData.sprintTasks);
    console.log("taskDetails", taskDetails, attributes);
    for (let k = 0; k < this.modelData.sprintTasks.length; k++) {
      if (this.modelData.sprintTasks[k].sprintName == taskDetails.sprintName) {
        if (
          taskDetails.activity.type == 'TN' ||
          taskDetails.activity.type == 'RM' ||
          taskDetails.activity.type == 'RI'
        ) {
          if (
            this.modelData.sprintTasks[k].activity.type == 'TN' ||
            this.modelData.sprintTasks[k].activity.type == 'RM' ||
            this.modelData.sprintTasks[k].activity.type == 'RI'
          ) {
            if (
              this.modelData.sprintTasks[k].sprintName == taskDetails.sprintName &&
              this.modelData.sprintTasks[k].entity_Id == taskDetails.entity_Id &&
              this.modelData.sprintTasks[k].attributes.symbol == attributes.symbol &&
              taskDetails.activity.type == this.modelData.sprintTasks[k].activity.type
            ) {
              // alert("Duplicate");
              // this.triggerToastPopup(this.appService.getResourceText('V020'));
              return;
            }
          }
        }
      }
    }
    // if (editDetails.task_combine_id) {
    //   let taskCombineUUID = editDetails.task_combine_id;
    // } else {

    //  else if (taskDetails.activity.type == 'FT') {
    //   this.generateFreeFormTask(taskDetails);
    // } else if (taskDetails.activity.type == 'RS') {
    //   this.generateRunSuiteTask(taskDetails);
    // } else if (taskDetails.activity.type == 'CL') {
    //   this.generateRunChecklistTask(taskDetails);
    // }
    // return;
    for (let i = 0; i < taskCreateArray.length; i++) {
      let taskDesc = '';
      let toolType = '';
      let createTask = true;
      if (taskCreateArray[i] == 'im') {
        // let entityFound = this.model.interactionMap.find(
        //   (inter: any) => inter.eut2 == taskDetails.entity_Id
        // );
        // if (entityFound) {
        //   createTask = false;
        // }
        toolType = 'im';
        taskDesc =
          'Map interactions' +
          // taskDetails.entityType +
          //for ' " - '" +
          // taskDetails.entity_desc +
          "";
      } else if (taskCreateArray[i] == 'dd') {
        // let ddFound = this.model.EUTdetails.find(
        //   (eut: any) => eut.eID == taskDetails.entity_Id
        // );
        // if (ddFound) {
        //   createTask = false;
        // }
        toolType = 'dd';
        taskDesc = "Deep dive";
        // " into '' + taskDetails.entity_desc + "
        
      } else if (taskCreateArray[i] == 'de') {
        // let ddFound = this.model.scenarios.find(
        //   (scen: any) =>
        //     scen.eID == taskDetails.entity_Id &&
        //     scen.tID == taskDetails.attributeSymbol
        // );
        // if (ddFound) {
        //   createTask = false;
        // }
        toolType = 'de';
        taskDesc =
          'Design for ' +
          attributes.name +
          // " - '" +
          // taskDetails.entity_desc +
          "";
      } else if (taskCreateArray[i] == 'ex') {
        if (taskDetails.environment) {
          taskDesc =
            taskDetails.activity.name + ' ' +
            // " '" +
            // taskDetails.entity_desc +
            // "' for " +
            attributes.name +
            ' on ' +
            taskDetails.environment;
        } else {
          taskDesc =
            taskDetails.activity.name + ' ' +
            // " '" +
            // taskDetails.entity_desc +
            // "' for " +
            attributes.name;
        }
        toolType = 'ex';
      }
      if (createTask == true) {
        // console.log("taskDesc", taskDesc);
        this.createTaskObj(taskCombineUUID, taskDetails, taskDesc, toolType, attributes, primaryEUTId);
      }
    }
  }

  createTaskObj(
    taskCombineUUID: any,
    taskDetails: any,
    taskDesc: any,
    toolType: any,
    attributes: any,
    primaryEUTId: any
  ) {
    // let taskDesc = "Do Design " + taskDetails.entity_desc + " for " + taskDetails.attribute;
    this.userDetails = window.localStorage.getItem("loginDetails");
    let user = JSON.parse(this.userDetails)
    let taskObj: any = {};
    taskObj.status = 1;
    taskObj.task_desc = taskDesc;
    taskObj.toolType = toolType;
    taskObj.task_combine_id = taskCombineUUID;
    taskObj.assignedto = user.userId;
    taskObj.assigneduser = user.user_display_name;
    taskObj.attributes = attributes;
    taskObj.activity = taskDetails.activity;
    if (taskDetails.environment) {
      taskObj.environment = taskDetails.environment;
    } else {
      taskObj.environment = '';
    }
    taskObj.sprintName = this.sprintName;
    taskObj.sprintID = this.selectedSprintDetails.sprintID;
    taskObj.entity_Id = taskDetails.entity_Id;
    taskObj.entity_desc = taskDetails.entity_desc;
    taskObj.entityType = taskDetails.entityType;
    if (primaryEUTId) {
      taskObj.primaryentity_Id = primaryEUTId;
    }
    taskObj.completed = false;
    taskObj.history = false;
    taskObj.checked = false;
    taskObj.taskId = this.uuidv4();
    taskObj.createdOn = new Date();
    // console.log("A", this.model.sprintTasks);
    console.log("task generated", taskObj);
    this.modelData.sprintTasks.push(taskObj);
    console.log("this.model.sprintTasks", this.modelData.sprintTasks);
  }
  //Updating scope map on task create
  updateScopeMap(taskDetails: any, attribute: any) {
    // console.log("TSK",taskDetails);
    // console.log("Attr", attribute);
    // console.log("sc",this.modelData.scopeMap);
    let scopeMapFound = this.modelData.scopeMap.find(
      (scope: any) => scope.eID == taskDetails.entity_Id && scope.aType == attribute.symbol
    );
    if (!scopeMapFound) {
      let scope = {
        "aType": attribute.symbol,
        "eID": taskDetails.entity_Id
      }
      this.modelData.scopeMap.push(scope);
      // console.log("scope",this.modelData.scopeMap);
    }
  }
  // addTaskToPlanner() {
  //   console.log('this.editTaskDetails', this.editTaskDetails);
  //   if (this.editTaskDetails.activity) {
  //     if (this.editTaskDetails.activity.type == 'RI') {
  //       let updateObj = {
  //         attribute: this.selectedAttribute,
  //         attributeSymbol: this.selectedAttributesymbol,
  //         environment: this.selectedEnvironment,
  //         assignedID: this.selectedPerson,
  //         assignedUser: this.personName,
  //       };
  //       this.updateImpactedEntityTask(this.editTaskDetails, updateObj);
  //       this.editTaskDetails = '';
  //       this.selectedActivity = 'New';
  //       this.selectedActivityObj = {
  //         type: 'TN',
  //         name: 'NEW',
  //         shortfoam: 'New',
  //       };
  //       this.tableCollapseExpand();
  //       this.resetTaskDetails(true);
  //       return;
  //     } else if (
  //       this.editTaskDetails.activity.type == 'RF' ||
  //       this.editTaskDetails.activity.type == 'RM'
  //     ) {
  //       if (
  //         this.editTaskDetails.entity_Id != this.selectedEntityId ||
  //         this.editTaskDetails.attribute != this.selectedAttribute
  //       ) {
  //         this.deleteTaskFromPlannerList(this.editTaskDetails, true);
  //       } else {
  //         this.updateModifyOrFixTask(
  //           this.editTaskDetails,
  //           this.selectedEnvironment,
  //           this.personName,
  //           this.selectedPerson
  //         );
  //         this.tableCollapseExpand();
  //         this.resetTaskDetails(true);
  //         this.loadPlanNamesList(this.tasks);
  //         return;
  //       }
  //     } else {
  //       this.deleteTaskFromPlannerList(this.editTaskDetails, true);
  //     }
  //   }
  //   if (this.plannerName == '') {
  //     this.triggerToastPopup(this.appService.getResourceText('V014'));
  //     // return -1;   //// commented temporarily
  //   }
  //   if (
  //     this.selectedActivityObj.type == 'TN' ||
  //     this.selectedActivityObj.type == 'RF' ||
  //     this.selectedActivityObj.type == 'RM'
  //   ) {
  //     if (this.selectedEntity == '' || this.selectedAttribute == '') {
  //       this.triggerToastPopup(this.appService.getResourceText('V016'));
  //       // return -1; //// commented temporarily
  //     }
  //   }
  //   if (this.selectedPerson == '' || this.selectedPerson == undefined) {
  //     this.triggerToastPopup(this.appService.getResourceText('V016'));
  //     // return -1; //// commented temporarily
  //   }
  //   this.newTaskDetails.task_desc = '';
  //   if (this.selectedAttribute != undefined) {
  //     this.newTaskDetails.attribute = this.selectedAttribute;
  //   } else {
  //     this.newTaskDetails.attribute = '';
  //   }
  //   if (this.selectedEnvironment != undefined) {
  //     this.newTaskDetails.environment = this.selectedEnvironment;
  //   } else {
  //     this.newTaskDetails.environment = '';
  //   }
  //   this.newTaskDetails.attributeSymbol = this.selectedAttributesymbol;
  //   this.newTaskDetails.entity_Id = this.selectedEntityId;
  //   this.newTaskDetails.entity_desc = this.selectedEntity;
  //   this.newTaskDetails.entityType = this.selectedEUT;
  //   this.newTaskDetails.plan_name = this.plannerName;
  //   this.newTaskDetails.plan_id = this.plannerID;
  //   if (this.selectedPerson == 'not assigned' || this.selectedPerson == '') {
  //     this.selectedPerson = 'not assigned';
  //     this.personName = 'not assigned';
  //     this.newTaskDetails.status = 0;
  //   } else {
  //     this.newTaskDetails.status = 1;
  //   }
  //   this.newTaskDetails.assignedto = this.selectedPerson;
  //   this.newTaskDetails.assigneduser = this.personName;
  //   this.newTaskDetails.activity = this.selectedActivityObj;
  //   if (this.selectedActivityObj.type == 'FT') {
  //     if (this.freeFormTestData == '') {
  //       this.triggerToastPopup(this.appService.getResourceText('V020c'));
  //       return;
  //       // return -1; //// commented temporarily
  //     } else {
  //       this.newTaskDetails.task_desc = this.freeFormTestData;
  //     }
  //   }
  //   if (this.selectedActivityObj.type == 'RS') {
  //     if (this.selectedSuite.suiteName === undefined) {
  //       this.triggerToastPopup(this.appService.getResourceText('V020b'));
  //       return;
  //     } else {
  //       this.newTaskDetails.selectedSuite = this.selectedSuite;
  //     }

  //   }
  //   if (this.selectedActivityObj.type == 'CL') {
  //     if (this.selectedChecklist.checklistId === undefined) {
  //       this.triggerToastPopup(this.appService.getResourceText('V020a'));
  //       return;
  //     } else {
  //       this.newTaskDetails.checklistDetails = this.selectedChecklist;
  //     }
  //   }
  //   this.checkTaskExists(this.newTaskDetails, this.editTaskDetails);
  //   this.tableCollapseExpand();
  //   this.loadPlanNamesList(this.tasks);
  //   // this.plannerComponent.loadMytasksList(this.tasks);
  //   this.reloadToolService.triggerTool(this.tasks);

  // }

  // checkTaskExists(newTaskDetails: any, editTaskDetails: any) {
  //   this.createTask(this.newTaskDetails, this.editTaskDetails);
  //   this.tableCollapseExpand();
  //   this.resetTaskDetails(false);
  // }

  createTasksForImpactedEntities() {
    this.createTasksForImpactedEntitiesModel();
    this.tableCollapseExpand();
  }
  getMappedAttributes(taskDetails: any) {
    this.selectedAttributesArray = [];
    for (let i = 0; i < this.modelData.scopeMap.length; i++) {
      if (this.modelData.scopeMap.eID == taskDetails.entity_Id) {
        let scopeFound = this.appConstlistOfAttributes.find(
          (scope: any) => scope.symbol == this.modelData.scopeMap[i].aType
        );
        if (scopeFound) {
          this.selectedAttributesArray.push(scopeFound);
        }
      }
    }
    console.log('this.selectedAttributesArray', this.selectedAttributesArray);
  }

  selectedTaskToEdit(taskDetails: any) {
    console.log('edit taskDetails', taskDetails);
    this.selectedActivityObj = taskDetails.activity;
    this.selectedActivity = taskDetails.activity.shortfoam;
    this.activityDisabled = true;
    this.EUTTypeDDisabled = false;
    this.EUTDDisabled = false;
    this.getMappedAttributes(taskDetails);
    // this.selectedAttributesArray.splice(0, this.selectedAttributesArray.length);
    if (
      taskDetails.activity.type == 'TN' ||
      taskDetails.activity.type == 'RF' ||
      taskDetails.activity.type == 'RM' ||
      taskDetails.activity.type == 'RI'
    ) {
      this.hideEUTDD = false;
      this.hideClistDD = true;
      this.hideEnvDD = true;
      this.hideSuitesDD = true;
      this.hideFTField = true;
      if (taskDetails.activity.type == 'RI') {
        this.EUTTypeDDisabled = true;
        this.EUTDDisabled = true;
        this.selectedActivity = 'Impact';
      }
    } else if (taskDetails.activity.type == 'CL') {
      this.hideEUTDD = true;
      this.hideClistDD = false;
      this.hideEnvDD = false;
      this.hideSuitesDD = true;
      this.hideFTField = true;
      this.attrDisabled = false;
      this.envDDDisabled = true;
      this.selectedChecklist = {};
      this.selectedEnvironment = '';
      this.singleEnvironmentName = '';
    } else if (taskDetails.activity.type == 'FT') {
      this.hideEUTDD = true;
      this.hideClistDD = true;
      this.hideEnvDD = true;
      this.hideSuitesDD = true;
      this.hideFTField = false;
      this.freeFormTestData = taskDetails.task_desc;
    }

    this.fieldsDisabled = false;
    this.planNameField = true;
    this.plannerPlusBtn = true;
    this.selectedEntity = {};
    this.selectedEnvironment = '';
    this.selectedPerson = '';
    this.entityName = '';
    this.attributeName = '';
    this.environmentName = '';
    this.personName = '';
    this.sprintName = '';
    this.editTaskDetails = taskDetails;
    this.singleEnvironmentName = taskDetails.environment;
    this.taskSelectedForModify = true;
    this.sprintName = this.editTaskDetails.sprintName;
    this.plannerID = this.editTaskDetails.plan_id;
    this.taskCombineId = this.editTaskDetails.task_combine_id;
    this.taskID = this.editTaskDetails.taskId;
    let entity = this.model.listOfEUTs.find(
      (eut: any) => eut.eID == this.editTaskDetails.entity_Id
    );
    if (entity == undefined) {
      let entity = {
        eID: taskDetails.entity_desc + taskDetails.sprintName,
        eName: taskDetails.entity_desc,
        eType: 'TT',
      };
      this.loadEntityDetails(entity, true);
    } else {
      this.loadEntityDetails(entity, true);
    }
    if (entity != undefined) {
      this.index = this.eutTypes.findIndex((type: any) => type == entity.eType);
    }
    let person = this.model.projectUserList.find(
      (person: any) => person._id == this.editTaskDetails.assignedto
    );
    if (person == undefined) {
      this.loadPersonDetails('not assigned');
    } else {
      this.loadPersonDetails(person);
    }
    this.selectedEnvironment = taskDetails.environment;
    for (const sprint of this.sprintTasks) {
      if (taskDetails.task_combine_id == sprint.task_combine_id) {
        this.selectedAttributesArray.push(sprint.attributes);
        this.selectedAttributesArray = this.getUniqueAttrArray(this.selectedAttributesArray)
      }
    }
    if (
      taskDetails.entity_Id ==
      taskDetails.entity_desc + taskDetails.sprintName
    ) {
      this.attrDisabled = true;
    } else {
      this.attrDisabled = false;
    }
    if (taskDetails.activity.type == 'CL') {
      if (taskDetails.checklistDetails.checkType == 'public') {
        let matchedChecklist = this.publicChecklists.find(
          (checklist: any) =>
            checklist._id == this.editTaskDetails.checklistDetails._id
        );
        this.selectedChecklist = matchedChecklist;
        this.envDDDisabled = false;
      } else {
        let matchedChecklist = this.model.checklists.find(
          (checklist: any) =>
            checklist.checklistId ==
            this.editTaskDetails.checklistDetails.checklistId
        );
        this.selectedChecklist = matchedChecklist;
        this.envDDDisabled = false;
      }
    }
    if (taskDetails.activity.type == 'RS') {
      let matchedSuite = this.suites.find(
        (suite: any) =>
          suite.suiteId == this.editTaskDetails.suiteDetails.suiteId
      );
      this.selectedSuite = matchedSuite;
      this.selectedSuiteName = matchedSuite.suiteName;
      this.envDDDisabled = false;
    }
  }

  getUniqueAttrArray(array: any) {
    let uniqueArray: any = [];
    if (array) {
      for (let i = 0; i < array.length; i++) {
        let USFound = uniqueArray.find((us: any) => us.symbol === array[i].symbol);
        if (USFound === undefined) {
          uniqueArray.push(array[i])
        }
      }
    }
    return uniqueArray;
  }

  deleteTaskFromPlanner() {
    return this.editTaskDetails._id;
  }

  resetTaskDetails(value: boolean) {
    this.attributeSelected = [];
    this.planNameField = false;
    this.plannerPlusBtn = false;
    if (value === false) {
      this.selectedEntity = '';
      this.selectedEntityId = '';
    }
    this.attrDisabled = false;
    // this.selectedAttributesArray.splice(0, this.selectedAttributesArray.length);
    if (this.selectedEUT == 'TT') {
      this.selectedAttributesArray.splice(0, this.selectedAttributesArray.length);
      this.allAttrList(this.selectedEUT);
    }
    this.selectedEnvironment = '';
    this.selectedPerson = '';
    this.entityName = '';
    this.attributeName = '';
    this.environmentName = '';
    this.singleEnvironmentName = '';
    this.personName = '';
    this.fieldsEnable(this.sprintName);
    this.taskSelectedForModify = false;
    this.taskCombineId = '';
    this.taskID = '';
    this.selectedSuite = {};
    this.selectedSuiteName = '';
    this.freeFormTestData = '';
    this.selectedChecklist = {};
    this.envDDDisabled = true;
    if (this.model.projectUserList.length <= 1) {
      let person = this.model.projectUserList.find(
        (person: any) => person._id == this.userIDTemp
      );
      this.loadPersonDetails(person);
    } else {
      this.personName = '';
      this.selectedPerson = '';
    }
    this.activityDisabled = false;
    if (this.EUTTypeDDisabled == true) {
      this.activityDisabled = false;
      this.EUTTypeDDisabled = false;
      this.EUTDDisabled = false;
    }
    this.editTaskDetails = {};
    return -1;
  }

  triggerToast(message: any) {
    this.toastMsg = message;
    $('#snackbar').html(message);
    let x: any = document.getElementById('snackbar');
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 3000);
  }

  entityExists(eType: any) {
    let entityPresent = this.entityExistsCheck(eType);
    return entityPresent;
  }

  getEntityType(eType: any) {
    let entityName = this.getEntityTypeCheck(eType);
    return entityName;
  }

  entityExistsCheck(eType: any) {
    let entities = this.modelData.listOfEUTs.filter(
      (entity: any) => entity.eType == eType
    );
    if (entities.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  getEntityTypeCheck(eType: any) {
    if (eType == 'TF') {
      return 'Features';
    } else if (eType == 'UR') {
      return 'Requirements';
    } else {
      return 'Flows';
    }
  }

  sprintEntityExists(eType: any) {
    let entityPresent = this.sprintEntityExistsCheck(eType);
    return entityPresent;
  }

  sprintEntityExistsCheck(eType: any) {
    let entities = this.modelData.sprintEUTs.filter(
      (entity: any) => entity.eType == eType
    );
    if (entities.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  checkTaskStatus(task: any) {
    this.matchedScenario = this.scenarios.find(
      (eut: any) => eut.eID == task.entity_Id
    );
    if (this.matchedScenario) {
      this.matchedRuninfo = this.runinfo.find(
        (run: any) => run.scenID == this.matchedScenario.scenID
      );
      if (this.matchedRuninfo) {
        if (this.matchedRuninfo.status == 'Y') {
          let reTest = 'RT';
          return reTest;
        } else {
          let reTest = 'T';
          return reTest;
        }
      } else {
        let reTest = 'T';
        return reTest;
      }
    }
    let reTest = 'T';
    return reTest;
  }

  sortTable(n: any) {
    let table: any,
      rows,
      switching,
      i,
      x,
      y,
      shouldSwitch,
      dir,
      switchcount = 0;
    table = document.getElementById('myTable2');
    switching = true;
    // Set the sorting direction to ascending:
    dir = 'asc';
    /* Make a loop that will continue until
    no switching has been done: */
    while (switching) {
      // Start by saying: no switching is done:
      switching = false;
      rows = table.rows;
      /* Loop through all table rows (except the
      first, which contains table headers): */
      for (i = 1; i < rows.length - 1; i++) {
        // Start by saying there should be no switching:
        shouldSwitch = false;
        /* Get the two elements you want to compare,
        one from current row and one from the next: */
        x = rows[i].getElementsByTagName('TD')[n];
        y = rows[i + 1].getElementsByTagName('TD')[n];
        /* Check if the two rows should switch place,
        based on the direction, asc or desc: */
        if (dir == 'asc') {
          if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
            // If so, mark as a switch and break the loop:
            shouldSwitch = true;
            break;
          }
        } else if (dir == 'desc') {
          if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
            // If so, mark as a switch and break the loop:
            shouldSwitch = true;
            break;
          }
        }
      }
      if (shouldSwitch) {
        /* If a switch has been marked, make the switch
        and mark that a switch has been done: */
        rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
        switching = true;
        // Each time a switch is done, increase this count by 1:
        switchcount++;
      } else {
        /* If no switching has been done AND the direction is "asc",
        set the direction to "desc" and run the while loop again. */
        if (switchcount == 0 && dir == 'asc') {
          dir = 'desc';
          switching = true;
        }
      }
    }
  }

  generateTasklistDescription(taskDetails: any) {
    if (taskDetails.activity.type == 'FT') {
      if (taskDetails.assigneduser == 'not assigned') {
        taskDetails.description =
          taskDetails.activity.name + ' "' + taskDetails.task_desc + '"';
      } else {
        taskDetails.description =
          taskDetails.activity.name +
          ' "' +
          taskDetails.task_desc +
          '" by ' +
          taskDetails.assigneduser;
      }
    } else if (taskDetails.activity.type == 'CL') {
      if (taskDetails.assigneduser == 'not assigned') {
        if (taskDetails.environment) {
          taskDetails.description =
            taskDetails.activity.name +
            ' for "' +
            taskDetails.checklistDetails.checklistName +
            '" on "' +
            taskDetails.environment +
            '"';
        } else {
          taskDetails.description =
            taskDetails.activity.name +
            ' for "' +
            taskDetails.checklistDetails.checklistName +
            '"';
        }
      } else {
        if (taskDetails.environment) {
          taskDetails.description =
            taskDetails.activity.name +
            ' for "' +
            taskDetails.checklistDetails.checklistName +
            '" on "' +
            taskDetails.environment +
            '" by ' +
            taskDetails.assigneduser;
        } else {
          taskDetails.description =
            taskDetails.activity.name +
            ' for "' +
            taskDetails.checklistDetails.checklistName +
            '" by ' +
            taskDetails.assigneduser;
        }
      }
    } else if (
      taskDetails.activity.type == 'TN' ||
      taskDetails.activity.type == 'RF' ||
      taskDetails.activity.type == 'RM' ||
      taskDetails.activity.type == 'RI'
    ) {
      if (taskDetails.environment == '') {
        if (taskDetails.assigneduser == 'not assigned') {
          taskDetails.description =
            taskDetails.activity.name +
            ' "' +
            taskDetails.entityType +
            ': ' +
            taskDetails.entity_desc +
            '" for "' +
            taskDetails.attributes.name +
            '"';
        } else {
          taskDetails.description =
            taskDetails.activity.name +
            ' "' +
            taskDetails.entityType +
            ': ' +
            taskDetails.entity_desc +
            '" for "' +
            taskDetails.attributes.name +
            '" by ' +
            taskDetails.assigneduser;
        }
      } else if (
        taskDetails.environment != '' ||
        taskDetails.environment != null ||
        taskDetails.environment != undefined
      ) {
        if (taskDetails.assigneduser == 'not assigned') {
          taskDetails.description =
            taskDetails.activity.name +
            ' "' +
            taskDetails.entityType +
            ': ' +
            taskDetails.entity_desc +
            '" for "' +
            taskDetails.attributes.name +
            '" on "' +
            taskDetails.environment +
            '"';
        } else {
          taskDetails.description =
            taskDetails.activity.name +
            ' "' +
            taskDetails.entityType +
            ': ' +
            taskDetails.entity_desc +
            '" for "' +
            taskDetails.attributes.name +
            '" on "' +
            taskDetails.environment +
            '" by ' +
            taskDetails.assigneduser;
        }
      }
      // console.log("Impacted", taskDetails.activity);
      if (taskDetails.activity.type == 'RI') {
        // console.log("Impacted", taskDetails);
        taskDetails.description = '--' + taskDetails.description;
      }
    }

    return taskDetails;
  }

  tableCollapseExpand() {
    // this.mySprintPlannerList.splice(0, this.mySprintPlannerList.length);
    let myNewSprintTasksList: any = [];
    let myTempTaskList = this.sprintTasks;
    // console.log('myTempTaskList', myTempTaskList);

    if (this.AttPlus == 1 && this.EnvPlus == 1) {
      for (let d = 0; d < myTempTaskList.length; d++) {
        if (myTempTaskList[d].sprintName == this.sprintName) {
          let taskFound = myNewSprintTasksList.find(
            (task: any) =>
              ((task.task_combine_id == myTempTaskList[d].task_combine_id) && (task.attributes.symbol == myTempTaskList[d].attributes.symbol))
          );
          if (taskFound) {
            if (myTempTaskList[d].activity.type == 'RI') {
              if (myTempTaskList[d].primaryentity_Id == taskFound.entity_Id) {
                let impactTaskFound = myNewSprintTasksList.find(
                  (task: any) =>
                  (task.task_combine_id === myTempTaskList[d].task_combine_id &&
                    task.impactedUnquieID === myTempTaskList[d].impactedUnquieID && myTempTaskList[d].impactedUnquieID !== undefined)
                );
                if (impactTaskFound) {
                  if (
                    impactTaskFound.partialExecute == false ||
                    impactTaskFound.partialExecute == undefined
                  ) {
                    if (
                      impactTaskFound.completed == myTempTaskList[d].completed
                    ) {
                      impactTaskFound.partialExecute = false;
                    } else {
                      impactTaskFound.partialExecute = true;
                    }
                  } else {
                    impactTaskFound.partialExecute = true;
                  }
                } else if (!impactTaskFound) {
                  myTempTaskList[d].partialExecute = false;
                  let index = myNewSprintTasksList.findIndex(
                    (task: any) =>
                      task.task_combine_id === taskFound.task_combine_id && task.attributes.symbol === taskFound.attributes.symbol
                  );
                  let indexImpact = myNewSprintTasksList.findIndex(
                    (task: any) =>
                      task.entity_Id === myTempTaskList[d].entity_Id &&
                      task.attributes.symbol === myTempTaskList[d].attributes.symbol &&
                      task.primaryentity_Id === myTempTaskList[d].primaryentity_Id
                  );
                  if (indexImpact === -1) {
                    myNewSprintTasksList.splice(
                      index + 1,
                      0,
                      this.generateTasklistDescription(myTempTaskList[d])
                    );
                  }

                }
              }
            } else {
              if (
                taskFound.partialExecute == false ||
                taskFound.partialExecute == undefined
              ) {
                if (taskFound.completed == myTempTaskList[d].completed) {
                  taskFound.partialExecute = false;
                } else {
                  taskFound.partialExecute = true;
                }
              } else {
                taskFound.partialExecute = true;
              }
            }
          } else {
            if (
              myTempTaskList[d].activity.type == 'TN' ||
              myTempTaskList[d].activity.type == 'RM' ||
              myTempTaskList[d].activity.type == 'FT' ||
              myTempTaskList[d].activity.type == 'CL'
            ) {
              myTempTaskList[d].partialExecute = false;
              myNewSprintTasksList.push(
                this.generateTasklistDescription(myTempTaskList[d])
              );
            }
          }
        }
      }
    }
    this.mySprintPlannerList = myNewSprintTasksList;
    console.log('mySprintPlannerList', this.mySprintPlannerList);
  }

  // to store selected plan name in local storage to generate exucutor report
  selectedPlannameToLS(planname: any) {
    this.modalPlannerName = planname;
    window.localStorage.setItem('selectedPlanname', this.modalPlannerName);
  }
  generateReport(auto: any) {
    window.localStorage.setItem('selectedPlanname', this.sprintName);
    let mapperArray = ['Task Planner'];
    window.localStorage.setItem('exportedData', JSON.stringify(mapperArray));
    window.localStorage.setItem(
      'scenarioEntity',
      JSON.stringify(['TF', 'UR', 'BF'])
    );
    if (auto == 'true') {
      window.open('/exportReport', '_blank');
      window.localStorage.setItem('autoDownload', 'true');
    }
  }
  /// ctrl fn close

  /// model fn open ======   ======

  taskImpactedEntities(task: any) {
    console.log('task', task);
    // this.impactedEntitiesChoosen.splice(0, this.impactedEntitiesChoosen.length)
    this.impactedEntitySelected = task;
    this.model.choosenEntity = task;
    this.model.mappedEntitiesChoosen = [];
    // console.log("task",task);
    // console.log("this.model.interactionMap",this.model.interactionMap);
    this.model.mappedEntities = [];
    this.model.unmappedEntities = [];
    for (let j = 0; j < this.model.entityTypes.length; j++) {
      for (let i = 0; i < this.model.interactionMap.length; i++) {
        if (task.entity_Id == this.model.interactionMap[i].eut2) {
          this.model.matchedTaskEntity = this.model.listOfEUTs.find(
            (eut: any) => eut.eID == this.model.interactionMap[i].eut1
          );
          if (this.model.matchedTaskEntity) {
            if (this.model.entityTypes[j] == this.model.matchedTaskEntity.eType) {
              this.model.matchedTaskEntity['task_combine_id'] = task.task_combine_id;
              this.model.mappedEntities.push(this.model.matchedTaskEntity);
            }
            // console.log("EUT", this.model.matchedTaskEntity);
          }
        }
      }
    }
    this.model.unmappedEntities = [...this.modelData.listOfEUTs];
    for (let k = 0; k < this.model.mappedEntities.length; k++) {
      for (let l = 0; l < this.model.unmappedEntities.length; l++) {
        if (this.model.mappedEntities[k].eID == this.model.unmappedEntities[l].eID) {
          this.model.unmappedEntities.splice(l, 1);
        }
      }
    }
    console.log("Mapped", this.model.mappedEntities);
    console.log("unMapped", this.model.unmappedEntities);
    for (let a = 0; a < this.model.sprintTasks.length; a++) {
      let selectedRIEntity = {};
      if (
        task.task_combine_id == this.model.sprintTasks[a].task_combine_id &&
        task.entity_Id == this.model.sprintTasks[a].primaryentity_Id &&
        this.model.sprintTasks[a].activity.type == 'RI'
      ) {
        selectedRIEntity = this.model.mappedEntities.find(
          (eut: any) => eut.eID == this.model.sprintTasks[a].entity_Id
        );
        if (selectedRIEntity) {
          this.selectImpactEUT(selectedRIEntity, true);
        }
      }
    }
    console.log("this.model.mappedEntities", this.model.mappedEntities);
  }

  //Check whether the entity in list is present in the imapacted entities
  isChecked(entity: any) {
    if (this.modelData.sprintEUTs.length > 0) {
      let p = this.modelData.sprintEUTs.findIndex(
        (eut: any) => eut.eID == entity.eID && eut.sprintName == this.sprintName
      );
      // console.log("p",p);
      // console.log("status",p > -1 ? true : false);
      return p > -1 ? true : false;
    } else {
      return; /// added to avoid error
    }
  }

  add(eut: any) {
    this.model.EUTdetails.push({
      eID: eut.eID,
      bc: '',
      ac: '',
      outcomes: '',
      bDescription: '',
      pIssues: '',
    });
  }
  triggerToastPopup(message: any) {
    this.toastMsgPopup = message;
    $('#taskPlannerMsgPopup1').modal('toggle');
  }

  updateModifyOrFixTask(
    editTaskDetails: any,
    env: any,
    personName: any,
    personId: any
  ) {
    // console.log("edit", editTaskDetails);
    // console.log(env,personName,personId);
    for (let i = 0; i < this.model.sprintTasks.length; i++) {
      if (
        this.model.sprintTasks[i].entity_Id == editTaskDetails.entity_Id &&
        this.model.sprintTasks[i].task_combine_id == editTaskDetails.task_combine_id
      ) {
        this.model.sprintTasks[i]['environment'] = env;
        this.model.sprintTasks[i]['assigneduser'] = personName;
        this.model.sprintTasks[i]['assignedto'] = personId;
        if (this.model.sprintTasks[i].toolType == 'ex') {
          if (env) {
            this.model.sprintTasks[i]['task_desc'] =
              editTaskDetails.activity.name +
              " '" +
              editTaskDetails.entity_desc +
              "' for " +
              editTaskDetails.attributes.name +
              ' on ' +
              env;
          } else {
            this.model.sprintTasks[i]['task_desc'] =
              editTaskDetails.activity.name +
              " '" +
              editTaskDetails.entity_desc +
              "' for " +
              editTaskDetails.attribute;
          }
        }
      }
    }
    // console.log("tasks",this.model.tasks);
  }
  // createTask(taskDetails: any, editDetails: any) {
  //   console.log('taskDe', taskDetails);
  //   // console.log("this.model.tasks",this.model.tasks);
  //   for (let k = 0; k < this.model.tasks.length; k++) {
  //     if (this.model.tasks[k].plan_name == taskDetails.plan_name) {
  //       if (
  //         taskDetails.activity.type == 'TN' ||
  //         taskDetails.activity.type == 'RM' ||
  //         taskDetails.activity.type == 'RF'
  //       ) {
  //         if (
  //           this.model.tasks[k].activity.type == 'TN' ||
  //           this.model.tasks[k].activity.type == 'RM' ||
  //           this.model.tasks[k].activity.type == 'RF'
  //         ) {
  //           // let taskFound = this.model.tasks.find(task => (task.plan_name == taskDetails.plan_name && task.entity_Id == taskDetails.entity_Id) && ((task.attribute == taskDetails.attribute && taskDetails.environment == task.environment) && taskDetails.activity.type == task.activity.type));
  //           if (
  //             this.model.tasks[k].plan_name == taskDetails.plan_name &&
  //             this.model.tasks[k].entity_Id == taskDetails.entity_Id &&
  //             this.model.tasks[k].attribute == taskDetails.attribute &&
  //             taskDetails.environment == this.model.tasks[k].environment &&
  //             taskDetails.activity.type == this.model.tasks[k].activity.type
  //           ) {
  //             this.triggerToastPopup(this.appService.getResourceText('V020'));
  //             return;
  //           }
  //         }
  //       } else if (taskDetails.activity.type == 'RS') {
  //         if (this.model.tasks[k].activity.type == 'RS') {
  //           // let taskFound = this.model.tasks.find(task => task.plan_name == taskDetails.plan_name && task.selectedSuite.suiteId == taskDetails.selectedSuite.suiteId && taskDetails.environment == task.environment);
  //           if (
  //             this.model.tasks[k].plan_name == taskDetails.plan_name &&
  //             this.model.tasks[k].selectedSuite.suiteId ==
  //             taskDetails.selectedSuite.suiteId &&
  //             taskDetails.environment == this.model.tasks[k].environment
  //           ) {
  //             this.triggerToastPopup(this.appService.getResourceText('V020'));
  //             return;
  //           }
  //         }
  //       } else if (taskDetails.activity.type == 'CL') {
  //         if (this.model.tasks[k].activity.type == 'CL') {
  //           if (taskDetails.checklistDetails.checkType == 'public') {
  //             // let taskFound = this.model.tasks.find(task => task.plan_name == taskDetails.plan_name && task.checklistDetails._id == taskDetails.checklistDetails._id && taskDetails.environment == task.environment);
  //             if (
  //               this.model.tasks[k].plan_name == taskDetails.plan_name &&
  //               this.tasks[k].checklistDetails._id ==
  //               taskDetails.checklistDetails._id &&
  //               taskDetails.environment == this.model.tasks[k].environment
  //             ) {
  //               this.triggerToastPopup(this.appService.getResourceText('V020'));
  //               return;
  //             }
  //           } else {
  //             // let taskFound = this.model.tasks.find(task => task.plan_name == taskDetails.plan_name && task.checklistDetails.checklistId == taskDetails.checklistDetails.checklistId && taskDetails.environment == task.environment);
  //             if (
  //               this.model.tasks[k].plan_name == taskDetails.plan_name &&
  //               this.model.tasks[k].checklistDetails.checklistId ==
  //               taskDetails.checklistDetails.checklistId &&
  //               taskDetails.environment == this.model.tasks[k].environment
  //             ) {
  //               this.triggerToastPopup(this.appService.getResourceText('V020'));
  //               return;
  //             }
  //           }
  //         }
  //       } else if (taskDetails.activity.type == 'FT') {
  //         if (this.model.tasks[k].activity.type == 'FT') {
  //           if (this.model.tasks[k].task_desc == taskDetails.task_desc) {
  //             this.triggerToastPopup(this.appService.getResourceText('V020'));
  //             return;
  //           }
  //         }
  //       }
  //     }
  //   }
  //   if (editDetails.task_combine_id) {
  //     let taskCombineUUID = editDetails.task_combine_id;
  //   } else {
  //     let taskCombineUUID: any = this.uuidv4();
  //   }
  //   let taskCreateArray: any = '';
  //   if (taskDetails.activity.type == 'TN') {
  //     taskCreateArray = ['pm', 'im', 'sm', 'dd', 'de', 'ex'];
  //   } else if (taskDetails.activity.type == 'RM') {
  //     taskCreateArray = ['dd', 'de', 'ex'];
  //   } else if (taskDetails.activity.type == 'RF') {
  //     taskCreateArray = ['dd', 'de', 'ex'];
  //     // let scenarioImExists = false;
  //     // for (let i = 0; i < this.model.scenarios.length; i++) {
  //     //   if (this.model.scenarios[i].eID == taskDetails.entity_Id && this.model.scenarios[i].tID == taskDetails.attributeSymbol) {
  //     //     scenarioImExists = true;
  //     //   }
  //     // }
  //     // if (scenarioImExists == false) {
  //     //   taskCreateArray = ["dd", "de", "ex"];
  //     // } else {
  //     //   taskCreateArray = ["ex"];
  //     // }
  //   } else if (taskDetails.activity.type == 'FT') {
  //     this.generateFreeFormTask(taskDetails);
  //   } else if (taskDetails.activity.type == 'RS') {
  //     this.generateRunSuiteTask(taskDetails);
  //   } else if (taskDetails.activity.type == 'CL') {
  //     this.generateRunChecklistTask(taskDetails);
  //   }

  //   for (let i = 0; i < taskCreateArray.length; i++) {
  //     let taskDesc = '';
  //     let toolType = '';
  //     let createTask = true;
  //     if (taskCreateArray[i] == 'pm') {
  //       if (taskDetails.entityType == 'UR') {
  //         let personaFound = this.model.personaMap.find(
  //           (per: any) => per.eID == taskDetails.entity_Id
  //         );
  //         if (personaFound) {
  //           createTask = false;
  //         }
  //       } else {
  //         createTask = false;
  //       }
  //       toolType = 'pm';
  //       taskDesc =
  //         'Map persona for ' +
  //         taskDetails.entityType +
  //         " - '" +
  //         taskDetails.entity_desc +
  //         "'";
  //     } else if (taskCreateArray[i] == 'im') {
  //       let entityFound = this.model.interactionMap.find(
  //         (inter: any) => inter.eut2 == taskDetails.entity_Id
  //       );
  //       if (entityFound) {
  //         createTask = false;
  //       }
  //       toolType = 'im';
  //       taskDesc =
  //         'Map interactions for ' +
  //         taskDetails.entityType +
  //         " - '" +
  //         taskDetails.entity_desc +
  //         "'";
  //     } else if (taskCreateArray[i] == 'sm') {
  //       let scopeFound = this.model.scopeMap.find(
  //         (scope: any) => scope.eID == taskDetails.entity_Id
  //       );
  //       if (scopeFound) {
  //         createTask = false;
  //       }
  //       toolType = 'sm';
  //       taskDesc =
  //         'Map scope for ' +
  //         taskDetails.entityType +
  //         " - '" +
  //         taskDetails.entity_desc +
  //         "'";
  //     } else if (taskCreateArray[i] == 'dd') {
  //       let ddFound = this.model.EUTdetails.find(
  //         (eut: any) => eut.eID == taskDetails.entity_Id
  //       );
  //       if (ddFound) {
  //         createTask = false;
  //       }
  //       toolType = 'dd';
  //       taskDesc = "Deep dive into '" + taskDetails.entity_desc + "'";
  //     } else if (taskCreateArray[i] == 'de') {
  //       let ddFound = this.model.scenarios.find(
  //         (scen: any) =>
  //           scen.eID == taskDetails.entity_Id &&
  //           scen.tID == taskDetails.attributeSymbol
  //       );
  //       if (ddFound) {
  //         createTask = false;
  //       }
  //       toolType = 'de';
  //       taskDesc =
  //         'Design for ' +
  //         taskDetails.attribute +
  //         " - '" +
  //         taskDetails.entity_desc +
  //         "'";
  //     } else if (taskCreateArray[i] == 'ex') {
  //       if (taskDetails.environment) {
  //         taskDesc =
  //           taskDetails.activity.name +
  //           " '" +
  //           taskDetails.entity_desc +
  //           "' for " +
  //           taskDetails.attribute +
  //           ' on ' +
  //           taskDetails.environment;
  //       } else {
  //         taskDesc =
  //           taskDetails.activity.name +
  //           " '" +
  //           taskDetails.entity_desc +
  //           "' for " +
  //           taskDetails.attribute;
  //       }
  //       toolType = 'ex';
  //     }
  //     if (createTask == true) {
  //       // console.log("taskDesc", taskDesc);
  //       this.createTaskObj(taskCombineUUID, taskDetails, taskDesc, toolType);
  //     }
  //   }
  // }

  // createTaskObj(
  //   taskCombineUUID: any,
  //   taskDetails: any,
  //   taskDesc: any,
  //   toolType: any
  // ) {
  //   // let taskDesc = "Do Design " + taskDetails.entity_desc + " for " + taskDetails.attribute;
  //   let taskObj: any = {};
  //   taskObj.status = taskDetails.status;
  //   taskObj.task_desc = taskDesc;
  //   taskObj.toolType = toolType;
  //   taskObj.task_combine_id = taskCombineUUID;
  //   taskObj.assignedto = taskDetails.assignedto;
  //   taskObj.assigneduser = taskDetails.assigneduser;
  //   taskObj.attribute = taskDetails.attribute;
  //   taskObj.activity = taskDetails.activity;
  //   if (taskDetails.environment) {
  //     taskObj.environment = taskDetails.environment;
  //   } else {
  //     taskObj.environment = '';
  //   }
  //   taskObj.plan_name = taskDetails.plan_name;
  //   taskObj.plan_id = taskDetails.plan_id;
  //   taskObj.entity_Id = taskDetails.entity_Id;
  //   taskObj.entity_desc = taskDetails.entity_desc;
  //   taskObj.entityType = taskDetails.entityType;
  //   taskObj.completed = false;
  //   taskObj.history = false;
  //   taskObj.checked = false;
  //   taskObj.taskId = this.uuidv4();
  //   taskObj.createdOn = new Date();
  //   this.model.tasks.push(taskObj);
  //   // console.log("this.model.tasks", this.model.tasks);
  // }
  generateFreeFormTask(taskDetails: any) {
    // console.log("free", taskDetails);
    let taskObj: any = {};
    taskObj.status = taskDetails.status;
    taskObj.task_desc = taskDetails.task_desc;
    taskObj.toolType = 'ft';
    taskObj.task_combine_id = this.uuidv4();
    taskObj.assignedto = taskDetails.assignedto;
    taskObj.assigneduser = taskDetails.assigneduser;
    // taskObj.attribute = taskDetails.attribute;
    taskObj.activity = taskDetails.activity;
    // if (taskDetails.environment) {
    //   taskObj.environment = taskDetails.environment;
    // } else {
    //   taskObj.environment = '';
    // }
    taskObj.sprintName = taskDetails.sprintName;
    // taskObj.entity_Id = taskDetails.entity_Id;
    // taskObj.entity_desc = taskDetails.entity_desc;
    // taskObj.entityType = taskDetails.entityType;
    taskObj.completed = false;
    taskObj.history = false;
    taskObj.checked = false;
    taskObj.taskId = this.uuidv4();
    taskObj.createdOn = new Date();
    this.model.sprintTasks.push(taskObj);
    // console.log("FREE TASK", this.model.sprintTasks);
  }
  generateRunSuiteTask(taskDetails: any) {
    // console.log("free", taskDetails);
    let taskObj: any = {};
    taskObj.status = taskDetails.status;
    if (taskDetails.environment) {
      taskObj.task_desc =
        taskDetails.activity.name +
        " for '" +
        taskDetails.selectedSuite.suiteName +
        "' on " +
        taskDetails.environment;
    } else {
      taskObj.task_desc =
        taskDetails.activity.name +
        " for '" +
        taskDetails.selectedSuite.suiteName +
        "'";
    }
    taskObj.toolType = 'tm';
    taskObj.task_combine_id = this.uuidv4();
    taskObj.suiteDetails = taskDetails.selectedSuite;
    taskObj.assignedto = taskDetails.assignedto;
    taskObj.assigneduser = taskDetails.assigneduser;
    taskObj.activity = taskDetails.activity;
    taskObj.selectedSuite = taskDetails.selectedSuite;
    if (taskDetails.environment) {
      taskObj.environment = taskDetails.environment;
    } else {
      taskObj.environment = '';
    }
    taskObj.sprintName = taskDetails.sprintName;
    taskObj.completed = false;
    taskObj.history = false;
    taskObj.checked = false;
    taskObj.taskId = this.uuidv4();
    taskObj.createdOn = new Date();
    this.model.sprintTasks.push(taskObj);
    // console.log("RUN SUITE", this.model.sprintTasks);
  }
  generateRunChecklistTask(taskDetails: any) {
    // console.log("free", taskDetails);
    let taskObj: any = {};
    taskObj.status = taskDetails.status;
    if (taskDetails.environment) {
      taskObj.task_desc =
        taskDetails.activity.name +
        " for '" +
        taskDetails.checklistDetails.checklistName +
        "' on " +
        taskDetails.environment;
    } else {
      taskObj.task_desc =
        taskDetails.activity.name +
        " for '" +
        taskDetails.checklistDetails.checklistName +
        "'";
    }
    taskObj.toolType = 'cl';
    taskObj.task_combine_id = this.uuidv4();
    taskObj.checklistDetails = taskDetails.checklistDetails;
    taskObj.assignedto = taskDetails.assignedto;
    taskObj.assigneduser = taskDetails.assigneduser;
    taskObj.activity = taskDetails.activity;
    if (taskDetails.environment) {
      taskObj.environment = taskDetails.environment;
    } else {
      taskObj.environment = '';
    }
    taskObj.sprintName = taskDetails.sprintName;
    taskObj.completed = false;
    taskObj.history = false;
    taskObj.checked = false;
    taskObj.taskId = this.uuidv4();
    taskObj.createdOn = new Date();
    this.model.sprintTasks.push(taskObj);
    console.log('RUN CHECKLIST', this.model.sprintTasks);
  }
  selectImpactEUT(eut: any, event: any) {
    // console.log("eut",eut);
    // console.log(event);
    if (event == true) {
      this.model.mappedEntitiesChoosen.push(eut);
    } else {
      this.model.mappedEntitiesChoosen = this.model.mappedEntitiesChoosen.filter(
        (obj: any) => {
          return obj.eID !== eut.eID;
        }
      );
    }
    // console.log("this.mappedEntitiesChoosen",this.model.mappedEntitiesChoosen);
  }

  selectSprintEUTs(eut: any, event: any) {
    console.log("id", this.sprintNamesArray);
    console.log("name", this.sprintName);
    console.log("eut", eut);

    let planIDFound = this.sprintNamesArray.find(
      (plan: any) => plan.sprintName == this.sprintName
    );

    let obj = {
      "eID": eut.eID,
      "eName": eut.eName,
      "eType": eut.eType,
      "sprintName": this.sprintName,
      "sprintID": this.plannerID
    }
    console.log("obj", obj);
    if (event == true) {
      this.modelData.sprintEUTs.push(obj);
    } else {
      this.modelData.sprintEUTs = this.modelData.sprintEUTs.filter(
        (obj: any) => {
          return obj.eID !== eut.eID;
        }
      );
    }
    console.log("this.modelData.sprintEUTs", this.modelData.sprintEUTs);
    // this.loadEntityDetails(eut, true);
  }
  selectJiraImpactEUTs(eut: any, event: any) {
    console.log("id", this.sprintNamesArray);
    console.log("name", this.sprintName);
    console.log("eut", eut);
    let sprintFound = this.sprintNamesArray.find(
      (plan: any) => plan.sprintName == this.sprintName
    );
    if (event == true) {
      let object = {
        "eID": this.uniqueID(eut.fields.eType),
        "eName": eut.fields.summary,
        "eType": eut.fields.eType,
        "scenarioCount": 0
      }
      let obj = {
        "entity_desc": eut.fields.summary,
      }
      if (this.checkEUTExists(obj) == false) {
        //Adding userstory/EUT to the eutlist
        this.modelData.listOfEUTs.unshift(object);
        this.chooseImpactedEUTs(object, 'true')
      }
    }
  }

  selectJiraSprintEUTs(eut: any, event: any) {
    console.log("id", this.sprintNamesArray);
    console.log("name", this.sprintName);
    console.log("eut", eut);
    console.log("this.modelData.sprintEUTs", this.modelData.sprintEUTs);
    let sprintFound = this.sprintNamesArray.find(
      (plan: any) => plan.sprintName == this.sprintName
    );



    if (event == true) {
      let obj = {
        "eID": this.uniqueID(eut.fields.eType),
        "eName": eut.fields.summary,
        "eType": eut.fields.eType,
        "sprintName": this.sprintName,
        "sprintID": sprintFound.sprintID
      }
      let object = {
        "eID": obj.eID,
        "eName": eut.fields.summary,
        "eType": eut.fields.eType,
        "scenarioCount": 0
      }

      let details = {
        "eID": obj.eID,
        "bc": "",
        "ac": "",
        "outcomes": "",
        "bDescription": eut.fields.description,
        "pIssues": ""
      }
      if (this.checkSprintEUTExists(obj) == false) {
        this.modelData.sprintEUTs.unshift(obj);
      }
      if (this.checkEUTExists(object) == false) {
        //Adding userstory/EUT to the eutlist
        this.modelData.listOfEUTs.unshift(object);
      }
      //Adding userstory/EUT details to the deepdive
      if (this.checkEUTDetailsExists(details) == false) {
        this.modelData.EUTdetails.unshift(details);
      }
    } else {
      // this.modelData.sprintEUTs = this.modelData.sprintEUTs.filter(
      //   (obj: any) => {
      //     return obj.eID !== eut.eID && obj.sprintName !== this.sprintName;
      //   }
      // );
      for (let i = 0; i < this.modelData.sprintEUTs.length; i++) {
        if (this.modelData.sprintEUTs[i].eName == eut.fields.summary && this.modelData.sprintEUTs[i].sprintName == this.sprintName) {
          this.modelData.sprintEUTs.splice(i, 1);
        }
      }
    }
    console.log("this.modelData.sprintEUTs", this.modelData.sprintEUTs);
    // console.log("this.modelData.listOfEUTs", this.modelData.listOfEUTs);
    // console.log("this.modelData.EUTdetails", this.modelData.EUTdetails);
    // this.loadEntityDetails(eut, true);
  }

  checkSprintEUTExists(entity: any) {
    let EUTfound = this.modelData.sprintEUTs.find(
      (eut: any) => eut.eID == entity.eID && eut.sprintName == entity.sprintName
    );
    if (EUTfound) {
      return true;
    } else {
      return false;
    }
  }

  checkEUTDetailsExists(entity: any) {
    let EUTDetailsfound = this.modelData.EUTdetails.find(
      (eut: any) => eut.eID == entity.eID
    );
    if (EUTDetailsfound) {
      return true;
    } else {
      return false;
    }
  }
  checkJiraImpactExists(fields: any) {
    // console.log("fields",fields);
    let EUTfound = this.modelData.sprintEUTs.find(
      (eut: any) => eut.eName == fields.summary && eut.sprintName == this.sprintName
    );
    if (EUTfound) {
      return true
    } else {
      return false
    }
  }
  checkJiraExists(fields: any) {
    // console.log("fields",fields);
    let EUTfound = this.modelData.sprintEUTs.find(
      (eut: any) => eut.eName == fields.summary && eut.sprintName == this.sprintName
    );
    if (EUTfound) {
      return true
    } else {
      return false
    }
  }

  updateSprintEUTs() {
    if (this.showSprintEntityList == 'addEUT') {
      this.addMultipleEuts();
    }
  }
  updateImpactedSprintEUTs() {
    this.deleteImpactedTasks();
    if (this.showImpactedEntityList == 'addEUT') {
      this.addMultipleImpactedEuts();
      setTimeout(() => {
        this.createImpactedTask();
      }, 1000);
    } else {
      this.createImpactedTask();
    }
  }

deleteImpactedTasks(){
  // console.log("selectedEUT", this.impactedEntitySelected);
  //   console.log("Impact", this.impactedEntitiesChoosen);

    for(let i =0; i < this.modelData.sprintTasks.length; i++){
      if(this.modelData.sprintTasks[i].activity.type == 'RI'){
        if(this.modelData.sprintTasks[i].task_combine_id == this.impactedEntitySelected.task_combine_id && this.modelData.sprintTasks[i].attributes.symbol == this.impactedEntitySelected.attributes.symbol){
          this.modelData.sprintTasks.splice(i, 1);
          i--;
        }
      }
    }
}

  addEnv() {
    let newEnvironmentObj = {
      //eid is the unique id generated for an environment,etype being the type ->tf,bf,fl
      envID: this.uniqueID('E'),
      envType: 'Freeform',
      envValues: [' ' + this.addEnvModel + ' '],
    };
    this.modelData.listOfEnv.unshift(newEnvironmentObj);
  }

  deleteTaskFromPlannerListModel(taskDetails: any) {
    // console.log("taskDetails",taskDetails);
    // console.log("this.modelData.sprintTasks",this.modelData.sprintTasks);
    // return;
    if (taskDetails.primaryentity_Id) {
      // console.log("i",taskDetails.primaryentity_Id);
      for (let i = 0; i < this.modelData.sprintTasks.length; i++) {
        if (
          this.modelData.sprintTasks[i].entity_Id == taskDetails.entity_Id &&
          this.modelData.sprintTasks[i].sprintID == taskDetails.sprintID &&
          this.modelData.sprintTasks[i].attributes.symbol == taskDetails.attributes.symbol &&
          this.modelData.sprintTasks[i].activity.type == taskDetails.activity.type
        ) {
          // console.log("i",this.modelData.sprintTasks[i]);
          this.modelData.sprintTasks.splice(i, 1);
          i--;
        }
      }
    } else {
      // console.log("else",taskDetails.primaryentity_Id);
      for (let j = 0; j < this.modelData.sprintTasks.length; j++) {
        if (
          this.modelData.sprintTasks[j].sprintName == taskDetails.sprintName &&
          this.modelData.sprintTasks[j].attributes.symbol == taskDetails.attributes.symbol &&
          this.modelData.sprintTasks[j].task_combine_id == taskDetails.task_combine_id
        ) {
          // console.log("j",this.modelData.sprintTasks[j]);
          this.modelData.sprintTasks.splice(j, 1);
          j--;
        }
      }
    }
  }

  createTasksForImpactedEntitiesModel() {
    // console.log("this.mappedEntitiesChoosen",this.model.mappedEntitiesChoosen);
    for (let j = 0; j < this.model.sprintTasks.length; j++) {
      // console.log("this.model.sprintTasks[j]", this.model.sprintTasks[j]);
      if (this.model.sprintTasks[j].activity) {
        if (this.model.sprintTasks[j].activity.type == 'RI') {
          if (this.model.choosenEntity.sprintName == this.model.sprintTasks[j].sprintName) {
            if (
              this.model.choosenEntity.task_combine_id ==
              this.model.sprintTasks[j].task_combine_id
            ) {
              // console.log(this.model.sprintTasks[j]);
              let exists = false;
              for (let k = 0; k < this.model.mappedEntitiesChoosen.length; k++) {
                if (
                  this.model.mappedEntitiesChoosen[k].task_combine_id ==
                  this.model.sprintTasks[j].task_combine_id
                ) {
                  if (
                    this.model.mappedEntitiesChoosen[k].eID == this.model.sprintTasks[j].entity_Id
                  ) {
                    exists = true;
                    this.model.mappedEntitiesChoosen.splice(k, 1);
                  }
                }
              }
              if (exists == false) {
                console.log(this.model.sprintTasks[j]);
                this.model.sprintTasks.splice(j, 1);
                j--;
              }
            }
          }
        }
      }
    }
    // console.log("this.model.sprintTasks",this.model.sprintTasks);
    // return;
    // console.log("this.model.mappedEntitiesChoosen", this.model.mappedEntitiesChoosen);
    for (let i = 0; i < this.model.mappedEntitiesChoosen.length; i++) {
      let attribute = '';
      let attributeSymbol = '';
      let impactedUnquieID = this.uuidv4();
      let taskCreateArray = ['dd', 'de', 'ex'];
      if (this.model.mappedEntitiesChoosen[i].eType == 'TF') {
        attribute = 'Feature Behaviour';
        attributeSymbol = 'Fe';
      } else if (this.model.mappedEntitiesChoosen[i].eType == 'UR') {
        attribute = 'Requirement Behaviour';
        attributeSymbol = 'Rb';
      } else if (this.model.mappedEntitiesChoosen[i].eType == 'BF') {
        attribute = 'Flow Behaviour';
        attributeSymbol = 'Fb';
      }
      // let scenarioImExists = false;
      // for (let j = 0; j < this.model.scenarios.length; j++) {
      //   if (this.model.scenarios[j].eID == this.model.mappedEntitiesChoosen[i].eID && this.model.scenarios[j].tID == attributeSymbol) {
      //     scenarioImExists = true;
      //   }
      // }
      // if (scenarioImExists == false) {
      //   taskCreateArray = ["dd", "de", "ex"];
      // } else {
      //   taskCreateArray = ["ex"];
      // }
      // console.log("array", taskCreateArray);
      for (let k = 0; k < taskCreateArray.length; k++) {
        let taskObj: any = {};
        let createTask = true;
        taskObj.status = this.model.choosenEntity.status;
        if (taskCreateArray[k] == 'dd') {
          let ddFound = this.model.EUTdetails.find(
            (eut: any) => eut.eID == this.model.mappedEntitiesChoosen[i].eID
          );
          if (ddFound) {
            createTask = false;
          }
          taskObj.task_desc =
            "Deep dive into '" + this.model.mappedEntitiesChoosen[i].eName + "'";
          taskObj.toolType = 'dd';
        } else if (taskCreateArray[k] == 'de') {
          let scenFound = this.model.scenarios.find(
            (scen: any) =>
              scen.eID == this.model.mappedEntitiesChoosen[i].eID &&
              scen.tID == attributeSymbol
          );
          if (scenFound) {
            createTask = false;
          }
          taskObj.task_desc =
            'Design for ' +
            attribute +
            " - '" +
            this.model.mappedEntitiesChoosen[i].eName +
            "'";
          taskObj.toolType = 'de';
        } else if (taskCreateArray[k] == 'ex') {
          if (this.model.choosenEntity.environment) {
            taskObj.task_desc =
              "IMP '" +
              this.model.mappedEntitiesChoosen[i].eName +
              "' for " +
              attribute +
              ' on ' +
              this.model.choosenEntity.environment;
          } else {
            taskObj.task_desc =
              "IMP '" +
              this.model.mappedEntitiesChoosen[i].eName +
              "' for " +
              attribute;
          }
          taskObj.toolType = 'ex';
        }
        taskObj.task_combine_id = this.model.choosenEntity.task_combine_id;
        taskObj.assignedto = this.model.choosenEntity.assignedto;
        taskObj.assigneduser = this.model.choosenEntity.assigneduser;
        taskObj.attribute = attribute;
        taskObj.activity = { type: 'RI', name: 'IMP' };
        taskObj.environment = this.model.choosenEntity.environment;
        taskObj.sprintName = this.model.choosenEntity.sprintName;
        taskObj.entity_Id = this.model.mappedEntitiesChoosen[i].eID;
        taskObj.entity_desc = this.model.mappedEntitiesChoosen[i].eName;
        taskObj.entityType = this.model.mappedEntitiesChoosen[i].eType;
        taskObj.primaryentity_Id = this.model.choosenEntity.entity_Id;
        taskObj.completed = false;
        taskObj.history = false;
        taskObj.checked = false;
        taskObj.taskId = this.uuidv4();
        taskObj.impactedUnquieID = impactedUnquieID;
        taskObj.createdOn = new Date();
        if (createTask == true) {
          // console.log("Desc", taskObj.task_desc);
          this.model.sprintTasks.push(taskObj);
        }
      }
    }
    // console.log("this.model.sprintTasks", this.model.sprintTasks);
  }
  updateImpactedEntityTask(editTaskDetails: any, updateObj: any) {
    console.log('edit', editTaskDetails);
    // console.log("tasks", this.model.sprintTasks);
    // console.log("obj",updateObj);
    let taskCreateArray = ['dd', 'de', 'ex'];
    // let scenarioImExists = false;
    // for (let j = 0; j < this.model.scenarios.length; j++) {
    //   if (this.model.scenarios[j].eID == editTaskDetails.entity_Id && this.model.scenarios[j].tID == updateObj.attributeSymbol) {
    //     scenarioImExists = true;
    //   }
    // }
    // if (scenarioImExists == false) {
    //   taskCreateArray = ["dd", "de", "ex"];
    // } else {
    //   taskCreateArray = ["ex"];
    // }
    for (let m = 0; m < this.model.sprintTasks.length; m++) {
      if (
        this.model.sprintTasks[m].primaryentity_Id == editTaskDetails.primaryentity_Id &&
        this.model.sprintTasks[m].impactedUnquieID == editTaskDetails.impactedUnquieID
      ) {
        this.model.sprintTasks.splice(m, 1);
        m--;
      }
    }
    let impactedUnquieID = this.uuidv4();
    for (let k = 0; k < taskCreateArray.length; k++) {
      let taskObj: any = {};
      let createTask = true;
      taskObj.status = this.model.choosenEntity.status;
      if (taskCreateArray[k] == 'dd') {
        let ddFound = this.model.EUTdetails.find(
          (eut: any) => eut.eID == editTaskDetails.entity_Id
        );
        if (ddFound) {
          createTask = false;
        }
        taskObj.task_desc =
          "Deep dive into '" + editTaskDetails.entity_desc + "'";
        taskObj.toolType = 'dd';
      } else if (taskCreateArray[k] == 'de') {
        let scenFound = this.model.scenarios.find(
          (scen: any) =>
            scen.eID == editTaskDetails.entity_Id &&
            scen.tID == updateObj.attributeSymbol
        );
        if (scenFound) {
          createTask = false;
        }
        taskObj.task_desc =
          'Design for ' +
          updateObj.attribute +
          " - '" +
          editTaskDetails.entity_desc +
          "'";
        taskObj.toolType = 'de';
      } else if (taskCreateArray[k] == 'ex') {
        if (updateObj.environment) {
          taskObj.task_desc =
            "IMP '" +
            editTaskDetails.entity_desc +
            "' for " +
            updateObj.attribute +
            ' on ' +
            updateObj.environment;
        } else {
          taskObj.task_desc =
            "IMP '" +
            editTaskDetails.entity_desc +
            "' for " +
            updateObj.attribute;
        }
        taskObj.toolType = 'ex';
      }
      taskObj.task_combine_id = editTaskDetails.task_combine_id;
      taskObj.assignedto = updateObj.assignedID;
      taskObj.assigneduser = updateObj.assignedUser;
      taskObj.attribute = updateObj.attribute;
      taskObj.activity = { type: 'RI', name: 'IMP' };
      taskObj.environment = updateObj.environment;
      taskObj.sprintName = editTaskDetails.sprintName;
      taskObj.entity_Id = editTaskDetails.entity_Id;
      taskObj.entity_desc = editTaskDetails.entity_desc;
      taskObj.entityType = editTaskDetails.entityType;
      taskObj.primaryentity_Id = editTaskDetails.primaryentity_Id;
      taskObj.completed = false;
      taskObj.history = false;
      taskObj.checked = false;
      taskObj.status = editTaskDetails.status;
      taskObj.taskId = this.uuidv4();
      taskObj.impactedUnquieID = impactedUnquieID;
      taskObj.createdOn = new Date();
      // console.log("taskObj",taskObj);
      if (createTask == true) {
        // console.log("Desc", taskObj.task_desc);
        this.model.sprintTasks.push(taskObj);
      }
    }
    // }
    // console.log("tasks RI update", this.model.sprintTasks);
  }
  addTask(taskDetails: any, editTaskDetails: any) {
    // console.log("editTaskDetails", editTaskDetails)
    // console.log("taskDetails", taskDetails);
    let taskCombineUUID = this.uuidv4();
    if (editTaskDetails) {
      let taskFound = this.model.sprintTasks.find(
        (task: any) =>
          task.sprintName == editTaskDetails.sprintName &&
          task.entity_Id == editTaskDetails.entity_Id &&
          task.attribute == editTaskDetails.attribute
      );
      if (taskFound) {
        this.deleteTask(editTaskDetails);
      }
    }
    let taskAttrFound = this.model.sprintTasks.find(
      (task: any) =>
        task.sprintName == taskDetails.sprintName &&
        task.entity_Id == taskDetails.entity_Id &&
        task.attribute == taskDetails.attribute &&
        task.task_desc ==
        'Do Design ' +
        taskDetails.entity_desc +
        ' for ' +
        taskDetails.attribute
    );
    // console.log("taskFound", taskAttrFound);
    if (!taskAttrFound) {
      let taskUUID = this.uuidv4();
      let taskDesc =
        'Do Design ' +
        taskDetails.entity_desc +
        ' for ' +
        taskDetails.attribute;
      let taskObj: any = {};
      taskObj.status = taskDetails.status;
      taskObj.task_desc = taskDesc;
      taskObj.task_combine_id = taskCombineUUID;
      taskObj.assignedto = taskDetails.assignedto;
      taskObj.assigneduser = taskDetails.assigneduser;
      taskObj.attribute = taskDetails.attribute;
      if (taskDetails.environment) {
        taskObj.environment = taskDetails.environment;
      } else {
        taskObj.environment = '';
      }
      taskObj.sprintName = taskDetails.sprintName;
      taskObj.entity_Id = taskDetails.entity_Id;
      taskObj.entity_desc = taskDetails.entity_desc;
      taskObj.completed = false;
      taskObj.history = false;
      taskObj.checked = false;
      taskObj.taskId = taskUUID;
      taskObj.createdOn = new Date();
      if (this.model.taskID && this.model.taskIndex) {
        this.model.sprintTasks.splice(this.model.taskIndex, 0, taskObj);
      } else {
        this.model.sprintTasks.push(taskObj);
      }
    }
    if (taskDetails.environment) {
      let environment;
      let taskUUID = this.uuidv4();
      if (taskDetails.environment) {
        environment = taskDetails.environment;
      } else {
        environment = '';
      }
      let taskDesc =
        'Do Validate ' +
        taskDetails.entity_desc +
        ' for ' +
        taskDetails.attributes.name +
        ' on ' +
        environment;
      let taskObj: any = {};
      taskObj.status = taskDetails.status;
      taskObj.task_desc = taskDesc;
      taskObj.task_combine_id = taskCombineUUID;
      taskObj.assignedto = taskDetails.assignedto;
      taskObj.assigneduser = taskDetails.assigneduser;
      if (taskDetails.attribute) {
        taskObj.attribute = taskDetails.attribute;
      } else {
        taskObj.attribute = '';
      }
      taskObj.environment = environment;
      taskObj.sprintName = taskDetails.sprintName;
      taskObj.entity_Id = taskDetails.entity_Id;
      taskObj.entity_desc = taskDetails.entity_desc;
      taskObj.completed = false;
      taskObj.history = false;
      taskObj.checked = false;
      taskObj.taskId = taskUUID;
      taskObj.createdOn = new Date();
      if (this.model.taskID && this.model.taskIndex) {
        this.model.sprintTasks.splice(this.model.taskIndex, 0, taskObj);
      } else {
        this.model.sprintTasks.push(taskObj);
      }
      // this.plannerComponent.loadMytasksList(this.model.sprintTasks);
      this.reloadToolService.triggerToolSprint(this.model.sprintTasks);

    }
  }

  deleteTask(det: any) {
    /// added temply
  }
  addTestTypeTask(taskDetails: any) {
    let environment
    let taskCombineUUID = this.uuidv4();
    let taskUUID = this.uuidv4();
    if (taskDetails.environment.length != 0) {
      environment = taskDetails.environment;
    } else {
      environment = '';
    }
    let taskDesc =
      'Execute ' +
      taskDetails.entity_desc +
      ' for ' +
      taskDetails.attribute.name +
      ' on ' +
      environment;
    let taskObj: any = {};
    taskObj.status = taskDetails.status;
    taskObj.task_desc = taskDesc;
    taskObj.task_combine_id = taskCombineUUID;
    taskObj.assignedto = taskDetails.assignedto;
    taskObj.assigneduser = taskDetails.assigneduser;
    if (taskDetails.attribute.length != 0) {
      taskObj.attribute = taskDetails.attribute;
    } else {
      taskObj.attribute = '';
    }
    taskObj.environment = taskDetails.environment;
    taskObj.sprintName = taskDetails.sprintName;
    taskObj.entity_Id = taskDetails.entity_Id;
    taskObj.entity_desc = taskDetails.entity_desc;
    taskObj.completed = false;
    taskObj.history = false;
    taskObj.checked = false;
    taskObj.taskId = taskUUID;
    taskObj.createdOn = new Date();
    if (this.model.taskID && this.model.taskIndex) {
      this.model.sprintTasks.splice(this.model.taskIndex, 0, taskObj);
    } else {
      this.model.sprintTasks.push(taskObj);
    }

    // this.plannerComponent.loadMytasksList(this.model.sprintTasks);
    this.reloadToolService.triggerToolSprint(this.model.sprintTasks);

  }

  updateTask(taskDetails: any, editTaskDetails: any) {
    this.addTask(taskDetails, editTaskDetails);
  }

  deletePlanModel(planname: any) {
    console.log('deletePlanModel planname', planname);
    for (let i = 0; i < this.modelData.sprintTasks.length; i++) {
      if (this.modelData.sprintTasks[i].sprintName == planname.sprintName) {
        this.modelData.sprintTasks.splice(i, 1);
        i--;
      }
    }
    for (let j = 0; j < this.modelData.sprintEUTs.length; j++) {
      if (this.modelData.sprintEUTs[j].sprintName == planname.sprintName) {
        this.modelData.sprintEUTs.splice(j, 1);
        j--;
      }
    }
    this.selectedSprintDetails = {};
  }

  // uuidv4() {
  //   return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
  //     let r = (Math.random() * 16) | 0,
  //       v = c == 'x' ? r : (r & 0x3) | 0x8;
  //     return v.toString(16);
  //   });
  // }

  /// model fn close
  getVideoURL(urlName: any) {
    let videoURL = this.appService.getVideoURL(urlName);
    let element: any = document.getElementById(urlName + 'VideoLink') || {};
    element.src = videoURL;
  }

  terminateVideo() {
    let iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, (iframe) => {
      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'stopVideo',
        }),
        '*'
      );
    });
  }

  sprintNameChanged(newname: any, oldname: any, updatePlanname: any) {
    if (newname != '') {
      let planExist = this.sprintNamesArray.find(
        (plan: any) => plan.sprintName.toUpperCase() == newname.toUpperCase()
      );
      if (planExist) {
        this.triggerToastPopup(this.appService.getResourceText('V019'));
      } else {
        if (updatePlanname == true) {

          for (let i = 0; i < this.modelData.sprintEUTs.length; i++) {
            if (this.modelData.sprintEUTs[i].sprintID == this.selectedSprintDetails.sprintID) {
              this.modelData.sprintEUTs[i]['sprintName'] = newname;
            }
            if (i === this.modelData.sprintEUTs.length - 1) {
              this.selectedSprintDetails.sprintName = newname;
              this.selectedSprint(false, false, this.selectedSprintDetails);
              this.reloadToolService.triggerToolSprint(this.sprintTasks);
            }
          }
          for (let j = 0; j < this.modelData.sprintTasks.length; j++) {
            if (this.modelData.sprintTasks[j].sprintID == this.selectedSprintDetails.sprintID) {
              this.modelData.sprintTasks[j].sprintName = newname;
            }
          }
        } else {




          this.resetPlanField(newname, this.uuidv4());
        }
        this.resetTaskData();
      }
    } else if (newname == '') {
      this.triggerToastPopup(this.appService.getResourceText('V019a'));
      return;
    }
  }

  showEntityAddPopup() {
    console.log('showEntityAddPopup called');
  }
}
